import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https: //  panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  // 首页
  {
    path: '/home',
    component: Layout,
    name: 'Home',
    redirect: '/home/home-page',
    meta: { title: '首页', icon: 'table' },
    children: [
      {
        path: 'home-page',
        name: 'HomePage',
        component: () => import('@/views/home/index'),
        meta: { title: '首页', icon: 'icon iconfont iconshangpin' }
      }
    ]
  },
  // 商品
  {
    path: '/goods',
    component: Layout,
    redirect: '/goods/goods-list',
    name: 'goods',
    meta: { title: '商品', icon: 'icon iconfont iconshangpin' },
    children: [
      {
        path: 'goods-list',
        name: 'GoodsList',
        component: () => import('@/views/goods/goods-list'),
        meta: { title: '商品列表', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'type-management',
        name: 'TypeManagement',
        component: () => import('@/views/goods/type-management'),
        meta: { title: '分类管理', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'edit',
        name: 'Edit',
        component: () => import('@/views/goods/edit'),
        meta: { title: '新增商品', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'label-management',
        name: 'LabelManagement',
        component: () => import('@/views/goods/label-management'),
        meta: { title: '标签管理', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'detail-template',
        name: 'DetailTemplate',
        component: () => import('@/views/goods/detail-template'),
        meta: { title: '详情模板', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'order-remark',
        name: 'Order-remark',
        component: () => import('@/views/order/order-remark'),
        meta: { title: '订单备注', icon: 'eye' }
      },
      {
        path: 'share-center',
        name: 'GoodsShare',
        component: () => import('@/views/goods/share'),
        meta: { title: '商品海报', icon: 'eye' }
      },
      {
        path: 'reserve/index',
        name: 'ReserveFund',
        component: () => import('@/views/goods/reserve/index'),
        meta: { title: '供应商收益', icon: 'eye' }
      },
      {
        path: 'college/goods-list',
        name: 'CollogeGoodsList',
        component: () => import('@/views/goods/college/goods-list'),
        meta: { title: '商品列表', icon: 'eye' }
      },
      {
        path: 'college/edit-goods',
        name: 'CollogeEditGoods',
        component: () => import('@/views/goods/college/edit-goods'),
        meta: { title: '新增商品', icon: 'eye' }
      },
      {
        path: 'college/type-mgmt',
        name: 'CollogeTypeMgmt',
        component: () => import('@/views/goods/college/type-mgmt'),
        meta: { title: '分类管理', icon: 'eye' }
      },
      {
        path: 'college/label-mgmt',
        name: 'CollogeLabelMgmt',
        component: () => import('@/views/goods/college/label-mgmt'),
        meta: { title: '标签管理', icon: 'eye' }
      },
      {
        path: 'comprehensive-poster',
        name: 'ComprehensivePoster',
        component: () => import('@/views/goods/comprehensive'),
        meta: { title: '综合海报', icon: 'eye' }
      }
    ]
  },
  // 团长管理
  {
    path: '/leader',
    component: Layout,
    redirect: '/leader/index',
    name: 'Leader',
    meta: { title: '团长管理', icon: 'icon iconfont iconshangpin' },
    children: [
      {
        path: 'index',
        name: 'CommunityGroupBuying',
        component: () => import('@/views/leader/index'),
        meta: { title: '团长列表', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'edit-community-group-buying',
        name: 'EditCommunityGroupBuying',
        component: () => import('@/views/leader/edit-community-group-buying'), //  Parent router-view
        meta: { title: '社区拼团' }
      },
      {
        path: 'leader-rule',
        name: 'LeaderRule',
        component: () => import('@/views/leader/rule'), //  Parent router-view
        meta: { title: '团长规则' }
      },
      // {
      //   path: 'leader-setting',
      //   name: 'LeaderSetting',
      //   component: () => import('@/views/leader/setting'), //  Parent router-view
      //   meta: { title: '社区团购' }
      // },
      {
        path: 'withdrawal',
        component: () => import('@/views/leader/withdrawal'), //  Parent router-view
        name: 'LeaderWithdrawal',
        meta: { title: '提现申请记录' }
      }
    ]
  },
  // 营销
  {
    path: '/marketing',
    component: Layout,
    redirect: '/marketing/index',
    name: 'marketing',
    meta: { title: '营销', icon: 'icon iconfont iconshangpin' },
    children: [
      {
        path: 'index',
        name: 'MarketingIndex',
        component: () => import('@/views/marketing/index'),
        meta: { title: '营销', icon: 'eye' }
      },
      {
        path: 'distribution-records',
        name: 'DistributionRecords',
        component: () => import('@/views/distribution/records'),
        meta: { title: '分销记录', icon: 'eye' }
      },
      {
        path: 'coupon-list',
        name: 'CouponList',
        component: () => import('@/views/marketing/coupon-list'),
        meta: { title: '优惠券列表', icon: 'eye' }
      },
      {
        path: 'limited-time-discounts',
        name: 'LimitedTimeDiscounts',
        component: () => import('@/views/marketing/limited-time-discounts'),
        meta: { title: '限时折扣', icon: 'eye' }
      },
      {
        path: 'edit-limited-time-discounts',
        name: 'EditLimitedTimeDiscounts',
        component: () =>
          import('@/views/marketing/edit-limited-time-discounts'),
        meta: { title: '新增限时折扣商品', icon: 'eye' }
      },
      {
        path: 'gift-cards',
        name: 'GiftCards',
        component: () => import('@/views/marketing/gift-cards'),
        meta: { title: '礼品卡', icon: 'eye' }
      },
      {
        path: 'add-gift-cards',
        name: 'AddGiftCards',
        component: () => import('@/views/marketing/add-gift-cards'),
        meta: { title: '新增礼品卡', icon: 'eye' }
      },
      {
        path: 'stored-cards',
        name: 'StoredCards',
        component: () => import('@/views/marketing/stored-cards'),
        meta: { title: '储值营销', icon: 'eye' }
      },
      {
        path: 'add-stored-cards',
        name: 'AddStoredCards',
        component: () => import('@/views/marketing/add-stored-cards'),
        meta: { title: '创建储值营销活动', icon: 'eye' }
      },
      {
        path: 'grade-cards',
        name: 'GradeCards',
        component: () => import('@/views/marketing/grade-cards'),
        meta: { title: '权益卡', icon: 'eye' }
      },
      {
        path: 'add-grade-cards',
        name: 'AddGradeCards',
        component: () => import('@/views/marketing/add-grade-cards'),
        meta: { title: '新增权益卡', icon: 'eye' }
      },
      {
        path: 'integral-mall',
        name: 'IntegralMall',
        component: () => import('@/views/marketing/integral-mall'),
        meta: { title: '积分商城', icon: 'eye' }
      },
      {
        path: 'add-integral-goods',
        name: 'AddIntegralGoods',
        component: () => import('@/views/marketing/add-integral-goods'),
        meta: { title: '新增积分商品', icon: 'eye' }
      },
      {
        path: 'buy-gifts',
        name: 'BuyGifts',
        component: () => import('@/views/marketing/buy-gifts'),
        meta: { title: '买N赠N', icon: 'eye' }
      },
      {
        path: 'add-buy-gifts-goods',
        name: 'AddBuyGiftsGoods',
        component: () => import('@/views/marketing/add-buy-gifts-goods'),
        meta: { title: '新增买N赠N活动', icon: 'eye' }
      },
      {
        path: 'edit-coupon',
        name: 'EditCoupon',
        component: () => import('@/views/marketing/edit-coupon'),
        meta: { title: '添加优惠券', icon: 'eye' }
      },
      {
        path: 'birthday-present',
        name: 'BirthdayPresent',
        component: () => import('@/views/marketing/birthday-present'),
        meta: { title: '生日礼', icon: 'eye' }
      },
      {
        path: 'edit-birthday-present',
        name: 'EditBirthdayPresent',
        component: () => import('@/views/marketing/edit-birthday-present'),
        meta: { title: '创建生日礼活动', icon: 'eye' }
      },
      {
        path: 'register-present',
        name: 'RegisterPresent',
        component: () => import('@/views/marketing/register-present'),
        meta: { title: '注册礼', icon: 'eye' }
      },
      {
        path: 'edit-register-present',
        name: 'EditRegisterPresent',
        component: () => import('@/views/marketing/edit-register-present'),
        meta: { title: '创建注册礼活动', icon: 'eye' }
      },
      {
        path: 'member-day',
        name: 'MemberDay',
        component: () => import('@/views/marketing/member-day'),
        meta: { title: '会员日', icon: 'eye' }
      },
      {
        path: 'edit-member-day',
        name: 'EditMemberDay',
        component: () => import('@/views/marketing/edit-member-day'),
        meta: { title: '创建会员日活动', icon: 'eye' }
      },
      {
        path: 'upgrade-present',
        name: 'UpgradePresent',
        component: () => import('@/views/marketing/upgrade-present'),
        meta: { title: '升级礼', icon: 'eye' }
      },
      {
        path: 'edit-upgrade-present',
        name: 'EditUpgradePresent',
        component: () => import('@/views/marketing/edit-upgrade-present'),
        meta: { title: '创建升级礼活动', icon: 'eye' }
      },
      {
        path: 'consume-present',
        name: 'ConsumePresent',
        component: () => import('@/views/marketing/consume-present'),
        meta: { title: '消费礼', icon: 'eye' }
      },
      {
        path: 'edit-consume-present',
        name: 'EditConsumePresent',
        component: () => import('@/views/marketing/edit-consume-present'),
        meta: { title: '创建消费礼活动', icon: 'eye' }
      },
      {
        path: 'precision-marketing',
        name: 'PrecisionMarketing',
        component: () => import('@/views/marketing/precision-marketing'),
        meta: { title: '精准营销', icon: 'eye' }
      },
      {
        path: 'edit-precision-marketing',
        name: 'EditPrecisionMarketing',
        component: () => import('@/views/marketing/edit-precision-marketing'),
        meta: { title: '创建精准营销活动', icon: 'eye' }
      },
      {
        path: 'mejm-activity',
        name: 'MejmActivity',
        component: () => import('@/views/marketing/mejm-activity'),
        meta: { title: '满额减', icon: 'eye' }
      },
      {
        path: 'edit-mejm-activity',
        name: 'EditMejmActivity',
        component: () => import('@/views/marketing/edit-mejm-activity'),
        meta: { title: '创建满额减活动', icon: 'eye' }
      },
      {
        path: 'entity-card',
        name: 'EntityCard',
        component: () => import('@/views/marketing/entity-card'),
        meta: { title: '实体卡', icon: 'eye' }
      },
      {
        path: 'SMS-marketing',
        name: 'SMSMarketing',
        component: () => import('@/views/marketing/SMS-marketing'),
        meta: { title: '短信', icon: 'eye' }
      },
      {
        path: 'wechat-native-card',
        name: 'WechartNativeCard',
        component: () => import('@/views/marketing/wechat-native-card'),
        meta: { title: '微信原生卡', icon: 'eye' }
      },
      {
        path: 'wechat-assistance',
        name: 'WechatAssistance',
        component: () => import('@/views/marketing/wechat-assistance'),
        meta: { title: '微助力', icon: 'eye' }
      },
      {
        path: 'edit-wechat-assistance',
        name: 'EditWechatAssistance',
        component: () => import('@/views/marketing/edit-wechat-assistance'),
        meta: { title: '微助力', icon: 'eye' }
      },
      {
        path: 'self-system-form',
        name: 'SelfSystemForm',
        component: () => import('@/views/marketing/form/self-system-form'),
        meta: { title: '自定义系统表单', icon: 'eye' }
      },
      {
        path: 'edit-system-form',
        name: 'SelfSystemFormEdit',
        component: () => import('@/views/marketing/form/self-system-form-edit'),
        meta: { title: '编辑自定义系统表单', icon: 'eye' }
      },
      {
        path: 'times-card',
        name: 'TimesCard',
        component: () => import('@/views/marketing/times-card'),
        meta: { title: '次卡', icon: 'eye' }
      },
      {
        path: 'edit-times-card',
        name: 'EditTimesCard',
        component: () => import('@/views/marketing/edit-times-card'),
        meta: { title: '新增次卡', icon: 'eye' }
      },
      {
        path: 'times-write-off-record',
        name: 'TimesWriteOffRecord',
        component: () => import('@/views/marketing/times-write-off-record'),
        meta: { title: '次卡核销记录', icon: 'eye' }
      },
      {
        path: 'free-receive-coupon',
        name: 'FreeReceiveCoupon',
        component: () => import('@/views/marketing/free-receive-coupon'),
        meta: { title: '免费领券', icon: 'eye' }
      },
      {
        path: 'edit-free-receive-coupon',
        name: 'EditFreeReceiveCoupon',
        component: () => import('@/views/marketing/edit-free-receive-coupon'),
        meta: { title: '新增免费领券', icon: 'eye' }
      },
      {
        path: 'sign-in-marketing',
        name: 'SignInMarketing',
        component: () => import('@/views/marketing/sign-in'),
        meta: { title: '签到', icon: 'eye' }
      },
      {
        path: 'edit-sign-in-marketing',
        name: 'EditSignInMarketing',
        component: () => import('@/views/marketing/edit-sign-in'),
        meta: { title: '创建签到活动', icon: 'eye' }
      },
      {
        path: 'big-turntable',
        name: 'BigTurntable',
        component: () => import('@/views/marketing/big-turntable'), //  Parent router-view
        meta: { title: '大转盘' }
      },
      {
        path: 'big-turntable-edit',
        name: 'BigTurntableEdit',
        component: () => import('@/views/marketing/big-turntable-edit'), //  Parent router-view
        meta: { title: '新增大转盘' }
      },
      {
        path: 'group-activity',
        name: 'GroupActivity',
        component: () => import('@/views/marketing/group-activity'), //  Parent router-view
        meta: { title: '拼团' }
      },
      {
        path: 'group-activity-edit',
        name: 'GroupActivityEdit',
        component: () => import('@/views/marketing/group-activity-edit'), //  Parent router-view
        meta: { title: '创建拼团活动' }
      },
      {
        path: 'seckill',
        name: 'Seckill',
        component: () => import('@/views/marketing/seckill'),
        meta: { title: '秒杀', icon: 'form' }
      },
      {
        path: 'edit-seckill',
        name: 'EditSeckill',
        component: () => import('@/views/marketing/edit-seckill'),
        meta: { title: '新增秒杀', icon: 'form' }
      },
      {
        path: 'cycle-card',
        name: 'CycleCard',
        component: () => import('@/views/marketing/cycle-card'),
        meta: { title: '周期卡', icon: 'form' }
      },
      {
        path: 'edit-cycle-card',
        name: 'EditCycleCard',
        component: () => import('@/views/marketing/edit-cycle-card'),
        meta: { title: '新增周期卡', icon: 'form' }
      },
      {
        path: 'cycle-write-off-record',
        name: 'CycleWriteOffRecord',
        component: () => import('@/views/marketing/cycle-write-off-record'),
        meta: { title: '周期卡签到记录', icon: 'eye' }
      },
      {
        path: 'live-broadcast',
        name: 'liveBroadcast',
        component: () => import('@/views/marketing/live-broadcast'),
        meta: { title: '直播带货', icon: 'eye' }
      },
      {
        path: 'bargain-index',
        name: 'BargainIndex',
        component: () => import('@/views/marketing/bargain/index'),
        meta: { title: '天天砍价', icon: 'eye' }
      },
      {
        path: 'bargain-edit',
        name: 'BargainEdit',
        component: () => import('@/views/marketing/bargain/edit'),
        meta: { title: '新增砍价商品', icon: 'eye' }
      },
      {
        path: 'bargain-record',
        name: 'BargainRecord',
        component: () => import('@/views/marketing/bargain/record'),
        meta: { title: '砍成记录', icon: 'eye' }
      },
      {
        path: 'bargain-renovation',
        name: 'BargainRenovation',
        component: () => import('@/views/marketing/bargain/renovation'),
        meta: { title: '砍价页面装修', icon: 'eye' }
      },
      {
        path: 'luck-draw-index',
        name: 'LuckDrawIndex',
        component: () => import('@/views/marketing/luck-draw/index'),
        meta: { title: '抽奖活动', icon: 'eye' }
      },
      {
        path: 'luck-draw-edit',
        name: 'LuckDrawEdit',
        component: () => import('@/views/marketing/luck-draw/edit'),
        meta: { title: '新增抽奖活动', icon: 'eye' }
      },
      {
        path: 'exchange-rules-setting',
        name: 'ExchangeRulesSetting',
        component: () => import('@/views/marketing/exchange-rules-setting'),
        meta: { title: '兑换规则', icon: 'eye' }
      },
      {
        path: 'register-present-rule',
        name: 'RegisterPresentRule',
        component: () => import('@/views/marketing/register-present-rule'),
        meta: { title: '兑换规则', icon: 'eye' }
      },
      {
        path: 'parcel',
        name: 'MarkcetingParcel',
        component: () => import('@/views/marketing/parcel/index'),
        meta: { title: '包邮活动', icon: 'eye' }
      },
      {
        path: 'parcel-edit',
        name: 'MarkcetingParcelEdit',
        component: () => import('@/views/marketing/parcel/edit'),
        meta: { title: '包邮活动', icon: 'eye' }
      },
      {
        path: 'jackport-record',
        name: 'MarkcetingJackpotRecord',
        component: () => import('@/views/marketing/jackpot/record'),
        meta: { title: '分红提现记录', icon: 'eye' }
      },
      {
        path: 'jackport-rule',
        name: 'MarkcetingJackpotRule',
        component: () => import('@/views/marketing/jackpot/rule'),
        meta: { title: '奖池规则', icon: 'eye' }
      },
      {
        path: 'complaint/company-index',
        name: 'MarkcetingComplaintCompanyIndex',
        component: () => import('@/views/marketing/complaint/company/index'),
        meta: { title: '投诉建议', icon: 'eye' }
      },
      {
        path: 'complaint/company-edit',
        name: 'MarkcetingComplaintCompanyEdit',
        component: () => import('@/views/marketing/complaint/company/edit'),
        meta: { title: '创建公司', icon: 'eye' }
      },
      {
        path: 'complaint/unit-index',
        name: 'MarkcetingComplaintUnitIndex',
        component: () => import('@/views/marketing/complaint/unit/index'),
        meta: { title: '单元列表', icon: 'eye' }
      },
      {
        path: 'complaint/unit-edit',
        name: 'MarkcetingComplaintUnitEdit',
        component: () => import('@/views/marketing/complaint/unit/edit'),
        meta: { title: '创建单元', icon: 'eye' }
      },
      {
        path: 'form-agreement',
        name: 'MarketFormAgreement',
        component: () => import('@/views/marketing/form-agreement/index'),
        meta: { title: '表单协议', icon: 'eye' }
      },
      {
        path: 'effective',
        name: 'MarketEffective',
        component: () => import('@/views/marketing/effective/index'),
        meta: { title: '时效卡', icon: 'eye' }
      },
      {
        path: 'effective/edit',
        name: 'MarketEffectiveEdit',
        component: () => import('@/views/marketing/effective/edit'),
        meta: { title: '编辑时效卡', icon: 'eye' }
      },
      {
        path: 'effective/record',
        name: 'MarketEffectiveERecord',
        component: () => import('@/views/marketing/effective/record'),
        meta: { title: '时效卡开通记录', icon: 'eye' }
      }
    ]
  },
  // 应用
  {
    path: '/application',
    component: Layout,
    redirect: '/application/index',
    name: 'Application',
    meta: { title: '应用', icon: 'icon iconfont iconicon_yingyong-mian' },
    children: [
      {
        path: 'index',
        name: 'ApplicationIndex',
        component: () => import('@/views/application/index'),
        meta: { title: '应用', icon: 'eye' }
      },
      {
        path: 'goods-setting',
        name: 'GoodsSetting',
        component: () => import('@/views/goods/setting'),
        meta: { title: '关联负责人', icon: 'eye' }
      },
      {
        path: 'leader-setting',
        name: 'LeaderSetting',
        component: () => import('@/views/leader/setting'), //  Parent router-view
        meta: { title: '社区团购' }
      },
      {
        path: 'supplier-setting',
        name: 'SupplierSetting',
        component: () => import('@/views/supplier/setting'),
        meta: { title: '多商家入驻', icon: 'form' }
      },
      {
        path: 'settlement-setting',
        name: 'LeaderSettlementRule',
        component: () => import('@/views/supplier/settlement-setting'),
        meta: { title: '供应商结算规则', icon: 'form' }
      },
      {
        path: 'package-fee-setting',
        name: 'PackageFeeSetting',
        component: () => import('@/views/application/package-fee-setting'),
        meta: { title: '打包费设置', icon: 'form' }
      },
      {
        path: 'inventory-setting',
        name: 'InventorySetting',
        component: () => import('@/views/application/inventory-setting'),
        meta: { title: '仓库管理', icon: 'form' }
      },
      {
        path: 'run-errands-setting',
        name: 'RunErrandsSetting',
        component: () => import('@/views/application/run-errands-setting'),
        meta: { title: '跑腿接单', icon: 'form' }
      },
      {
        path: 'goods-inventory-setting',
        name: 'GoodsInventorySetting',
        component: () => import('@/views/application/goods-inventory-setting'),
        meta: { title: '商品库', icon: 'form' }
      },
      {
        path: 'goods-img-inventory',
        name: 'GoodsImgInventory',
        component: () => import('@/views/application/goods-img-inventory'),
        meta: { title: '商品库', icon: 'form' }
      },
      {
        path: 'staff-evaluate-setting',
        name: 'StaffEvaluateSetting',
        component: () => import('@/views/application/staff-evaluate-setting'),
        meta: { title: '员工评价', icon: 'form' }
      },
      {
        path: 'news-setting',
        name: 'ReleaseInfomationSetting',
        component: () =>
          import('@/views/application/release-infomation-setting'),
        meta: { title: '发布资讯', icon: 'form' }
      },
      {
        path: 'service-mode-setting',
        name: 'ServiceModeSetting',
        component: () => import('@/views/application/service-mode-setting'),
        meta: { title: '服务模式', icon: 'form' }
      },
      {
        path: 'wechart-service-setting',
        name: 'weChartServiceSetting',
        component: () => import('@/views/enterprise/wechart-service-setting'),
        meta: { title: '企业微信客服', icon: 'form' }
      },
      {
        path: 'information-collector',
        name: 'InformationCollector',
        component: () => import('@/views/application/information-collector'),
        meta: { title: '信息采集器', icon: 'form' }
      },
      {
        path: 'movie/index',
        name: 'ApplicationMovieIndex',
        component: () => import('@/views/application/movie/index'),
        meta: { title: '电影票', icon: 'form' }
      },
      {
        path: 'movie-setting',
        name: 'MovieSetting',
        component: () => import('@/views/application/movie/movie-setting'),
        meta: { title: '电影票设置', icon: 'form' }
      },
      {
        path: 'takeout/index',
        name: 'TakeOutIndex',
        component: () => import('@/views/application/takeout/index'),
        meta: { title: 'CPS红包', icon: 'form' }
      },
      {
        path: 'red-packet-setting',
        name: 'RedPacketSetting',
        component: () =>
          import('@/views/application/takeout/red-packet-setting'),
        meta: { title: 'CPS红包规则', icon: 'form' }
      },
      {
        path: 'reserve-fund',
        name: 'TakeoutReserveFund',
        component: () => import('@/views/application/takeout/reserve-fund'),
        meta: { title: '储备金流水', icon: 'form' }
      },
      {
        path: 'goods-list-inventory',
        name: 'GoodsListInventory',
        component: () => import('@/views/application/supply'),
        meta: { title: '选品中心', icon: 'form' }
      },
      {
        path: 'edit-goods-list-inventory',
        name: 'EditGoodsListInventory',
        component: () => import('@/views/application/supply/edit'),
        meta: { title: '发布商品', icon: 'form' }
      },
      {
        path: 'goods-code',
        name: 'ExportGoodsCode',
        component: () => import('@/views/application/goods-code/index'),
        meta: { title: '核销码导出', icon: 'form' }
      },
      {
        path: 'goods-code-detail',
        name: 'ExportGoodsCodeDetail',
        component: () => import('@/views/application/goods-code/code-detail'),
        meta: { title: '导出核销码明细', icon: 'form' }
      },
      {
        path: 'custom-service',
        name: 'CustomService',
        component: () => import('@/views/service/custom-service'),
        meta: { title: '店铺客服', icon: 'eye' }
      },
      {
        path: 'dealer-setting',
        name: 'DealerSetting',
        component: () => import('@/views/application/dealer-setting'),
        meta: { title: '经销商', icon: 'eye' }
      },
      {
        path: 'shopowner-distribution',
        name: 'ShopownerDistribution',
        component: () => import('@/views/application/shopowner/distribution'),
        meta: { title: '店长分销记录', icon: 'eye' }
      },
      {
        path: 'shopowner-mgmt',
        name: 'ShopownerMgmt',
        component: () => import('@/views/application/shopowner/mgmt'),
        meta: { title: '店长管理', icon: 'eye' }
      },
      {
        path: 'shopowner-rule',
        name: 'ShopownerRule',
        component: () => import('@/views/application/shopowner/rule'),
        meta: { title: '店长规则', icon: 'eye' }
      },
      {
        path: 'deposit',
        name: 'ApplicationDeposit',
        component: () => import('@/views/application/deposit'),
        meta: { title: '押金', icon: 'eye' }
      },
      {
        path: 'order-restriction',
        name: 'ApplicationOrderRestriction',
        component: () => import('@/views/application/order-restriction/index'),
        meta: { title: '订单限购', icon: 'eye' }
      },
      {
        path: 'continue-to-order',
        name: 'ApplicationContinueToOrder',
        component: () => import('@/views/application/continue-to-order'),
        meta: { title: '继续下单', icon: 'eye' }
      },
      {
        path: 'water-function',
        name: 'ApplicationWaterFunction',
        component: () => import('@/views/application/water-function'),
        meta: { title: '送水功能', icon: 'eye' }
      },
      {
        path: 'overlord-meal',
        name: 'ApplicationOverlordMeal',
        component: () => import('@/views/application/overlord-meal'),
        meta: { title: '霸王餐功能', icon: 'eye' }
      },
      {
        path: 'wechat-group',
        name: 'ApplicationWechatGroup',
        component: () => import('@/views/application/wechat-group'),
        meta: { title: '企业微信群页', icon: 'eye' }
      },
      {
        path: 'advertisement',
        name: 'AdvertisementIndex',
        component: () => import('@/views/advertisement/index'),
        meta: { title: '微信广告', icon: 'eye' }
      }
    ]
  },
  // 饿了么订单导入
  {
    path: '/application',
    component: Layout,
    redirect: '/application/elm-order-import',
    name: 'Application',
    children: [
      {
        path: 'elm-order-import',
        name: 'ElmOrderImport',
        component: () => import('@/views/application/elm-order-import'),
        meta: { title: '饿了么订单导入', icon: 'form' }
      }
    ]
  },
  // 订单
  {
    path: '/order',
    component: Layout,
    redirect: '/order/order-management',
    name: 'Order',
    meta: { title: '订单', icon: 'example' },
    children: [
      // {
      //   path: 'order-remark',
      //   name: 'OrderRemark',
      //   component: () => import('@/views/order/order-remark'),
      //   meta: { title: '订单备注', icon: 'eye' }
      // },
      {
        path: 'transaction-settings',
        name: 'TransactionSettings',
        component: () => import('@/views/order/transaction-settings'),
        meta: { title: '规则设置', icon: 'eye' }
      },
      {
        path: 'order-management',
        name: 'OrderManagement',
        component: () => import('@/views/order/order-management'),
        meta: { title: '订单管理', icon: 'eye' }
      },
      {
        path: 'order-refund',
        name: 'OrderRefund',
        component: () => import('@/views/order/order-refund'),
        meta: { title: '退款处理', icon: 'eye' }
      },
      {
        path: 'order-return',
        name: 'OrderReturn',
        component: () => import('@/views/order/order-return'),
        meta: { title: '退货处理', icon: 'eye' }
      },
      {
        path: 'sheet-to-be-printed',
        name: 'SheetToBePrinted',
        component: () => import('@/views/order/sheet-to-be-printed'),
        meta: { title: '待打印面单', icon: 'eye' }
      }
    ]
  },
  // 库存
  {
    path: '/inventory',
    component: Layout,
    redirect: '/inventory/warehouse-in-mgmt',
    name: 'Inventory',
    meta: { title: '库存', icon: 'icon iconfont iconicon_yingyong-mian' },
    children: [
      {
        path: 'warehouse-in-mgmt',
        name: 'WarehouseInMgmt',
        component: () => import('@/views/inventory/warehouse-in-mgmt'),
        meta: { title: '入库管理', icon: 'eye' }
      },
      {
        path: 'warehouse-out-mgmt',
        name: 'WarehouseOutMgmt',
        component: () => import('@/views/inventory/warehouse-out-mgmt'),
        meta: { title: '出库管理', icon: 'eye' }
      },
      {
        path: 'warehouse-allot',
        name: 'WarehouseAllot',
        component: () => import('@/views/inventory/warehouse-allot'),
        meta: { title: '库存调拨', icon: 'eye' }
      },
      {
        path: 'warehouse-check',
        name: 'WarehouseCheck',
        component: () => import('@/views/inventory/warehouse-check'),
        meta: { title: '库存盘点', icon: 'eye' }
      },
      {
        path: 'warehouse-warning',
        name: 'WarehouseWarning',
        component: () => import('@/views/inventory/warehouse-warning'),
        meta: { title: '库存预警', icon: 'eye' }
      },
      {
        path: 'warehouse-in-and-out',
        name: 'WarehouseInAndOut',
        component: () => import('@/views/inventory/warehouse-in-and-out'),
        meta: { title: '出入库汇总', icon: 'eye' }
      },
      {
        path: 'warehouse-in-and-out-detail',
        name: 'WarehouseInAndOutDetail',
        component: () =>
          import('@/views/inventory/warehouse-in-and-out-detail'),
        meta: { title: '出入库明细', icon: 'eye' }
      },
      {
        path: 'warehouse-mgmt',
        name: 'WarehouseMgmt',
        component: () => import('@/views/inventory/warehouse-mgmt'),
        meta: { title: '仓库管理', icon: 'eye' }
      },
      {
        path: 'add-warehouse',
        name: 'AddWarehouse',
        component: () => import('@/views/inventory/add-warehouse'),
        meta: { title: '新增入库', icon: 'eye' }
      },
      {
        path: 'edit-warehouse-mgmt',
        name: 'EditWarehouseMgmt',
        component: () => import('@/views/inventory/edit-warehouse-mgmt'),
        meta: { title: '新增仓库', icon: 'eye' }
      },
      {
        path: 'warehouse-area',
        name: 'WarehouseArea',
        component: () => import('@/views/inventory/warehouse-area'),
        meta: { title: '仓库区域管理', icon: 'eye' }
      },
      {
        path: 'add-warehouse-out',
        name: 'AddWarehouseOut',
        component: () => import('@/views/inventory/add-warehouse-out'),
        meta: { title: '新增出库', icon: 'eye' }
      },
      {
        path: 'edit-warehouse-allot',
        name: 'EditWarehouseAllot',
        component: () => import('@/views/inventory/edit-warehouse-allot'),
        meta: { title: '新增调拨单', icon: 'eye' }
      },
      {
        path: 'edit-warehouse-check',
        name: 'EditWarehouseCheck',
        component: () => import('@/views/inventory/edit-warehouse-check'),
        meta: { title: '新增盘点', icon: 'eye' }
      },
      {
        path: 'confirm-warehouse-out',
        name: 'ConfirmWarehouseOut',
        component: () => import('@/views/inventory/confirm-warehouse-out'),
        meta: { title: '确认出库单', icon: 'eye' }
      },
      {
        path: 'confirm-warehouse-in',
        name: 'ConfirmWarehouseIn',
        component: () => import('@/views/inventory/confirm-warehouse-in'),
        meta: { title: '确认入库单', icon: 'eye' }
      },
      {
        path: 'confirm-warehouse-allot',
        name: 'ConfirmWarehouseAllot',
        component: () => import('@/views/inventory/confirm-warehouse-allot'),
        meta: { title: '确认入库单', icon: 'eye' }
      }
    ]
  },
  // 收银
  // {
  //   path: '/cash',
  //   component: Layout,
  //   redirect: '/cash/set-cash-register',
  //   name: 'Cash',
  //   meta: { title: '收银设置', icon: 'example' },
  //   children: [
  //     {
  //       path: 'set-pay-style',
  //       name: 'SetPayStyle',
  //       component: () => import('@/views/cash/set-pay-style'),
  //       meta: { title: '支付规则', icon: 'eye' }
  //     }
  //   ]
  // },
  // 系统
  {
    path: '/system',
    component: Layout,
    // redirect: '/system/shop-information',
    name: 'System',
    meta: { title: '系统', icon: 'example' },
    children: [
      {
        path: 'shop-information',
        name: 'ShopInformation',
        component: () => import('@/views/system/shop-information'),
        meta: { title: '门店管理', icon: 'eye' }
      },
      {
        path: 'staff-list',
        name: 'RoleList',
        component: () => import('@/views/system/staff-list'),
        meta: { title: '员工管理', icon: 'eye' }
      },
      {
        path: 'edit-staff', // 角色标记有单独的菜单
        name: 'EditStaff',
        component: () => import('@/views/system/edit-staff'),
        meta: { title: '添加员工', icon: 'eye' }
      },
      {
        path: 'edit-role', // 角色标记有单独的菜单
        name: 'EditRole',
        component: () => import('@/views/system/edit-role'),
        meta: { title: '角色管理', icon: 'eye' }
      },
      {
        path: 'express-template',
        name: 'ExpressTemplate',
        component: () => import('@/views/system/express-template'),
        meta: { title: '快递模板', icon: 'eye' }
      },
      {
        path: 'logistics-settings',
        name: 'LogisticsSettings',
        component: () => import('@/views/system/logistics-settings'),
        meta: { title: '物流设置', icon: 'eye' }
      },
      {
        path: 'edit-express-template',
        name: 'EditExpressTemplate',
        component: () => import('@/views/system/edit-express-template'),
        meta: { title: '创建快递模板', icon: 'eye' }
      },
      {
        path: 'edit-role-permission',
        name: 'editRolePermission',
        component: () => import('@/views/system/edit-role-permission'),
        meta: { title: '权限配置', icon: 'eye' }
      },
      {
        path: 'print-configuration',
        name: 'PrintConfiguration',
        component: () => import('@/views/system/print-configuration'),
        meta: { title: '打印配置', icon: 'eye' }
      },
      {
        path: 'city-distribution',
        name: 'CityDistribution',
        component: () => import('@/views/system/city-distribution'),
        meta: { title: '同城配送', icon: 'eye' }
      },
      {
        path: 'brand-information',
        name: 'BrandInformation',
        component: () => import('@/views/system/brand-information'),
        meta: { title: '品牌信息', icon: 'eye' }
      },
      {
        path: 'account-set',
        name: 'AccountSet',
        component: () => import('@/views/system/account-set'),
        meta: { title: '出入账号设置', icon: 'eye' }
      },
      {
        path: 'decoration/index',
        name: 'DecorationIndex',
        component: () => import('@/views/system/decoration/index'),
        meta: { title: '小程序装修', icon: 'eye' }
      },
      {
        path: 'set-cash-register',
        name: 'SetCashRegister',
        component: () => import('@/views/system/set-cash-register'),
        meta: { title: '收银设置', icon: 'eye' }
      },
      {
        path: 'receiving-account',
        name: 'ReceivingAccount',
        component: () => import('@/views/system/receiving-account'),
        meta: { title: '收款账号', icon: 'eye' }
      },
      {
        path: 'internal-push',
        name: 'InternalPush',
        component: () => import('@/views/system/internal-push'),
        meta: { title: '内部推送', icon: 'eye' }
      },
      {
        path: 'custom-basic',
        component: () => import('@/views/system/custom/index'), //  Parent router-view
        name: 'CustomBasic',
        meta: { title: '公司自定义配置' }
      },
      {
        path: 'service-range',
        component: () => import('@/views/system/service-range'), //  Parent router-view
        name: 'ServiceRange',
        meta: { title: '服务范围' }
      },
      {
        path: 'special-permission',
        component: () => import('@/views/system/special-permission'), //  Parent router-view
        name: 'SpecialPermission',
        meta: { title: '特殊权限' }
      },
      {
        path: 'work-handover',
        component: () => import('@/views/system/work-handover'), //  Parent router-view
        name: 'SpecialPermission',
        meta: { title: '工作交接' }
      },
      {
        path: 'shop/index',
        name: 'collegeShopIndex2',
        component: () => import('@/views/system/shop/index'),
        meta: { title: '店铺信息', icon: 'eye' }
      },
      {
        path: 'shop/edit',
        name: 'collegeShopEdit2',
        component: () => import('@/views/system/shop/edit'),
        meta: { title: '编辑店铺信息', icon: 'eye' }
      },
      {
        path: 'shop/qualifications',
        name: 'collegeShopQualifications',
        component: () => import('@/views/system/shop/qualifications'),
        meta: { title: '商家资质', icon: 'eye' }
      },
      {
        path: 'shop/distribution',
        name: 'collegeShopDistribution2',
        component: () => import('@/views/system/shop/distribution'),
        meta: { title: '配送设置', icon: 'eye' }
      },
      {
        path: 'brand/index',
        name: 'collegeBrandIndex2',
        component: () => import('@/views/system/brand/index'),
        meta: { title: '品牌信息', icon: 'eye' }
      },
      {
        path: 'brand/distribution',
        name: 'collegeBrandDistribution',
        component: () => import('@/views/system/brand/distribution'),
        meta: { title: '配送设置', icon: 'eye' }
      },
      {
        path: 'shop/print-configuration',
        name: 'collegePrintConfiguration2',
        component: () => import('@/views/system/shop/print-configuration'),
        meta: { title: '打印配置', icon: 'eye' }
      },
      {
        path: 'shop/account-set',
        name: 'collegeShopAccountSet2',
        component: () => import('@/views/system/shop/account-set'),
        meta: { title: '收银设置', icon: 'eye' }
      },
      {
        path: 'building/index',
        name: 'collegeBuildingIndex2',
        component: () => import('@/views/college/building/index'),
        meta: { title: '楼栋管理', icon: 'eye' }
      },
      {
        path: 'brand/account-set',
        name: 'collegeBrandAccountSet',
        component: () => import('@/views/system/brand/account-set'),
        meta: { title: '出入账号设置', icon: 'eye' }
      },
      {
        path: 'channel/index',
        name: 'collegeSystemChannelIndex',
        component: () => import('@/views/system/channel/index'),
        meta: { title: 'H5链接', icon: 'eye' }
      }
    ]
  },
  // 会员
  {
    path: '/user',
    component: Layout,
    redirect: '/user/user-list',
    name: 'UserList',
    meta: { title: '会员', icon: 'example' },
    children: [
      {
        path: 'user-list',
        name: 'UserList',
        component: () => import('@/views/user/user-list'),
        meta: { title: '会员列表', icon: 'eye' }
      },
      // {
      //   path: 'user-grade',
      //   name: 'UserGrade',
      //   component: () => import('@/views/user/user-grade'),
      //   meta: { title: '会员等级', icon: 'eye' }
      // },
      // {
      //   path: 'edit-grade',
      //   name: 'EditGrade',
      //   component: () => import('@/views/user/edit-grade'),
      //   meta: { title: '新增会员等级', icon: 'eye' }
      // },
      // {
      //   path: 'grade-rule',
      //   name: 'GradeRule',
      //   component: () => import('@/views/user/grade-rule'),
      //   meta: { title: '等级规则', icon: 'eye' }
      // },
      {
        path: 'edit-user',
        name: 'EditUser',
        component: () => import('@/views/user/edit-user'),
        meta: { title: '会员详情', icon: 'eye' }
      },
      {
        path: 'user-tags',
        name: 'UserTags',
        component: () => import('@/views/user/user-tags'),
        meta: { title: '标签管理', icon: 'eye' }
      },
      {
        path: 'expand-information',
        name: 'ExpandInfomation',
        component: () => import('@/views/user/expand-information'),
        meta: { title: '会员拓展信息', icon: 'eye' }
      },
      {
        path: 'all-user-list',
        name: 'AllUserList',
        component: () => import('@/views/user/all-user-list'),
        meta: { title: '全品牌会员列表', icon: 'eye' }
      },
      {
        path: 'guest-detail',
        name: 'GuestDetail',
        component: () => import('@/views/user/guest-detail'),
        meta: { title: '会员信息', icon: 'eye' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/user-grade',
    name: 'UserGrade',
    meta: { title: '会员', icon: 'example' },
    children: [
      {
        path: 'user-grade',
        name: 'UserGrade',
        component: () => import('@/views/user/user-grade'),
        meta: { title: '会员等级', icon: 'eye' }
      },
      {
        path: 'edit-grade',
        name: 'EditGrade',
        component: () => import('@/views/user/edit-grade'),
        meta: { title: '新增会员等级', icon: 'eye' }
      },
      {
        path: 'grade-rule',
        name: 'GradeRule',
        component: () => import('@/views/user/grade-rule'),
        meta: { title: '等级规则', icon: 'eye' }
      },
      {
        path: 'all-user-grade',
        name: 'AllUserGrade',
        component: () => import('@/views/user/all-user-grade'),
        meta: { title: '全品牌会员等级', icon: 'eye' }
      },
      {
        path: 'edit-all-grade',
        name: 'EditAllGrade',
        component: () => import('@/views/user/edit-all-grade'),
        meta: { title: '新增公司会员等级', icon: 'eye' }
      },
      {
        path: 'grade-upgrade',
        name: 'UserGradeUpgrade',
        component: () => import('@/views/user/grade/upgrade'),
        meta: { title: '升级规则', icon: 'eye' }
      },
      {
        path: 'demotion-index',
        name: 'UserDemotionIndex',
        component: () => import('@/views/user/demotion/index'),
        meta: { title: '降级规则', icon: 'eye' }
      }
    ]
  },
  // 服务员
  {
    path: '/waiter',
    component: Layout,
    redirect: '/waiter/service-mgmt',
    name: 'Waiter',
    meta: { title: '服务员', icon: 'example' },
    children: [
      {
        path: 'service-mgmt',
        component: () => import('@/views/waiter/service-mgmt'), //  Parent router-view
        name: 'ServiceMgmt',
        meta: { title: '服务管理' }
      },
      {
        path: 'waiter-mgmt',
        component: () => import('@/views/appointment/waiter-mgmt'), //  Parent router-view
        name: 'WaiterMgmt',
        meta: { title: '添加服务人员' }
      },
      {
        path: 'group-mgmt',
        component: () => import('@/views/appointment/group-mgmt'), //  Parent router-view
        name: 'GroupMgmt',
        meta: { title: '分组管理' }
      },
      {
        path: 'waiter-achievement',
        name: 'WaiterAchievement',
        component: () => import('@/views/waiter/achievement'),
        meta: { title: '订单明细', icon: 'eye' }
      }
    ]
  },
  // 服务员评价
  {
    path: '/waitereva',
    component: Layout,
    redirect: '/waitereva/index',
    name: 'Waitereva',
    meta: { title: '服务员评价', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'WaiterevaIndex',
        component: () => import('@/views/waitereva/index'),
        meta: { title: '服务员评价', icon: 'eye' }
      },
      {
        path: 'evaluate-tag',
        name: 'EvaluationTag',
        component: () => import('@/views/waitereva/tag'),
        meta: { title: '评价标签管理', icon: 'eye' }
      }
    ]
  },
  // 订单评价
  {
    path: '/ordereva',
    component: Layout,
    redirect: '/ordereva/index',
    name: 'Ordereva',
    meta: { title: '订单评价', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'OrderevaIndex',
        component: () => import('@/views/ordereva/index'),
        meta: { title: '订单评价列表', icon: 'eye' }
      },
      {
        path: 'order-evaluate-tag',
        name: 'OrderEvaluationTag',
        component: () => import('@/views/ordereva/tag'),
        meta: { title: '评价标签管理', icon: 'eye' }
      }
    ]
  },
  // 门店评价
  {
    path: '/shopeva',
    component: Layout,
    redirect: '/shopeva/index',
    name: 'Shopeva',
    meta: { title: '门店评价', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'ShopIndex',
        component: () => import('@/views/shopeva/index'),
        meta: { title: '门店评价列表', icon: 'eye' }
      },
      {
        path: 'shop-evaluate-tag',
        name: 'ShopEvaluationTag',
        component: () => import('@/views/shopeva/tag'),
        meta: { title: '评价标签管理', icon: 'eye' }
      }
    ]
  },
  // 工作台
  {
    path: '/custom',
    component: Layout,
    redirect: '/custom/index',
    name: 'Custom',
    meta: { title: '工作台', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'TestIndex',
        component: () => import('@/views/custom/index'),
        meta: { title: '工作台', icon: 'eye' }
      }
    ]
  },
  // 工作台
  // {
  //   path: '/custom',
  //   component: Layout,
  //   redirect: '/custom/index',
  //   name: 'CustomSy',
  //   meta: { title: '工作台', icon: 'example' },
  //   children: [
  //     {
  //       path: 'custom/index',
  //       component: () => import('@/views/custom/index'), //  Parent router-view
  //       name: 'CustomPage',
  //       meta: { title: '工作台' }
  //     }
  //   ]
  // },
  // 统计
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/cross-shop-settlement',
    name: 'CrossShopSettlement',
    meta: { title: '统计', icon: 'example' },
    children: [
      {
        path: 'cross-shop-settlement',
        name: 'CrossShopSettlement',
        component: () => import('@/views/statistics/cross-shop-settlement'),
        meta: { title: '跨店结算', icon: 'eye' }
      },
      {
        path: 'goods-statistics',
        name: 'GoodsStatistics',
        component: () => import('@/views/statistics/goods-statistics'),
        meta: { title: '商品统计', icon: 'eye' }
      },
      {
        path: 'order-statistics',
        name: 'OrderStatistics',
        component: () => import('@/views/statistics/order-statistics'),
        meta: { title: '订单统计', icon: 'eye' }
      },
      {
        path: 'user-statistics',
        name: 'UserStatistics',
        component: () => import('@/views/statistics/user-statistics'),
        meta: { title: '业务汇总', icon: 'eye' }
      },
      {
        path: 'business-summary',
        name: 'BusinessSummary',
        component: () => import('@/views/statistics/business-summary'),
        meta: { title: '营业统计', icon: 'eye' }
      },
      {
        path: 'all-business-summary',
        name: 'AllBusinessSummary',
        component: () => import('@/views/statistics/all-business-summary'),
        meta: { title: '全品牌营业统计', icon: 'eye' }
      },
      {
        path: 'all-cross-shop-settlement',
        name: 'AllCrossShopSettlement',
        component: () => import('@/views/statistics/all-cross-shop-settlement'),
        meta: { title: '全品牌跨店结算', icon: 'eye' }
      },
      {
        path: 'flow-statistics',
        name: 'FlowStatistics',
        component: () => import('@/views/statistics/flow-statistics'),
        meta: { title: '流量统计', icon: 'eye' }
      },
      {
        path: 'appointment-statistics',
        name: 'AppointmentStatistics',
        component: () => import('@/views/statistics/appointment-statistics'),
        meta: { title: '预约统计', icon: 'eye' }
      },
      {
        path: 'settlement-statistics',
        name: 'SettlementStatistics',
        component: () => import('@/views/statistics/settlement-statistics'),
        meta: { title: '结算统计', icon: 'eye' }
      },
      {
        path: 'handover-statistics',
        name: 'HandoverStatistics',
        component: () => import('@/views/statistics/handover-statistics'),
        meta: { title: '交接记录', icon: 'eye' }
      }
    ]
  },
  // 发布资讯
  {
    path: '/news',
    component: Layout,
    redirect: '/news/index',
    name: 'ReleaseNews',
    meta: { title: '发布资讯', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'ReleaseNewsIndex',
        component: () => import('@/views/news/index'),
        meta: { title: '资讯', icon: 'eye' }
      },
      {
        path: 'edit-news',
        name: 'EditNews',
        component: () => import('@/views/news/edit-news'),
        meta: { title: '发布资讯', icon: 'eye' }
      },
      {
        path: 'poster',
        name: 'NewsPoster',
        component: () => import('@/views/news/poster/index'),
        meta: { title: '分享海报', icon: 'eye' }
      },
      {
        path: 'quotations',
        name: 'NewsQuotations',
        component: () => import('@/views/news/quotations/index'),
        meta: { title: '分享语录', icon: 'eye' }
      }
    ]
  },
  // 预约
  {
    path: '/appointment',
    component: Layout,
    redirect: '/appointment/index',
    name: 'Appointment',
    meta: {
      title: '预约',
      icon: 'nested'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/appointment/index'), //  Parent router-view
        name: 'AppointmentIndex',
        meta: { title: '预约列表' }
      },
      {
        path: 'edit-appointment',
        component: () => import('@/views/appointment/edit-appointment'), //  Parent router-view
        name: 'EditAppointment',
        meta: { title: '新增预约' }
      },
      {
        path: 'type-list',
        component: () => import('@/views/appointment/type-list'), //  Parent router-view
        name: 'AppointmentType',
        meta: { title: '预约项目类型' }
      },
      {
        path: 'tag-list',
        component: () => import('@/views/appointment/tag-list'), //  Parent router-view
        name: 'AppointmentTag',
        meta: { title: '预约项目标签' }
      },
      {
        path: 'source-template',
        component: () => import('@/views/appointment/source-template'), //  Parent router-view
        name: 'SourceTemplate',
        meta: { title: '位置排序' }
      }
    ]
  },
  // 企业微信客服
  {
    path: '/enterprise',
    component: Layout,
    redirect: '/enterprise/index',
    name: 'Enterprise',
    meta: { title: '企业微信客服', icon: 'nested' },
    children: [
      {
        path: 'index',
        name: 'WechartService',
        component: () => import('@/views/enterprise/index'),
        meta: { title: '客服', icon: 'dashboard' }
      },
      {
        path: 'role-mgmt',
        name: 'RoleMgmt',
        component: () => import('@/views/enterprise/role-mgmt'),
        meta: { title: '角色管理', icon: 'dashboard' }
      },
      {
        path: 'chat-mgmt',
        name: 'ChatMgmt',
        component: () => import('@/views/enterprise/chat'),
        meta: { title: '查询聊天', icon: 'dashboard' }
      }
    ]
  },
  // 游戏
  {
    path: '/game',
    component: Layout,
    redirect: '/game/index',
    name: 'Game',
    meta: { title: '游戏', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'GameIndex',
        component: () => import('@/views/game/index'),
        meta: { title: '游戏', icon: 'eye' }
      }
    ]
  },
  // 404
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  // 欢迎页
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '欢迎页', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/example',
    component: Layout,
    redirect: '/example/table',
    name: 'Example',
    meta: { title: 'Example', icon: 'example' },
    children: [
      {
        path: 'table',
        name: 'Table',
        component: () => import('@/views/table/index'),
        meta: { title: 'Table', icon: 'table' }
      },
      {
        path: 'tree',
        name: 'Tree',
        component: () => import('@/views/tree/index'),
        meta: { title: 'Tree', icon: 'tree' }
      }
    ]
  },
  {
    path: '/test',
    component: Layout,
    redirect: '/test/index',
    //  name: 'Test',
    children: [
      {
        path: 'index',
        name: 'MyTest',
        component: () => import('@/views/test/index'),
        meta: { title: 'index', icon: 'eye' }
      }
    ]
  },
  // 分销
  {
    path: '/distribution',
    component: Layout,
    redirect: '/marketing/index',
    name: 'Distribution',
    meta: {
      title: '营销',
      icon: 'nested'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/distribution/index'), //  Parent router-view
        name: 'DistributionIndex',
        meta: { title: '分销活动' }
      },
      {
        path: 'records',
        component: () => import('@/views/distribution/records'), //  Parent router-view
        name: 'DistributionRecords',
        meta: { title: '分销记录' }
      },
      {
        path: 'rule',
        component: () => import('@/views/distribution/rule'), //  Parent router-view
        name: 'DistributionRule',
        meta: { title: '分销规则' }
      },
      {
        path: 'order',
        component: () => import('@/views/distribution/order'), //  Parent router-view
        name: 'DistributionOrder',
        meta: { title: '订单明细' }
      },
      {
        path: 'withdrawal',
        component: () => import('@/views/distribution/withdrawal'), //  Parent router-view
        name: 'Withdrawal',
        meta: { title: '分销提现申请记录' }
      },
      {
        path: 'distributor',
        component: () => import('@/views/distribution/distributor'), //  Parent router-view
        name: 'Distributor',
        meta: { title: '分销商' }
      },
      {
        path: 'advanced-distribution',
        component: () => import('@/views/distribution/advanced'), //  Parent router-view
        name: 'AdvancedDistribution',
        meta: { title: '高级分销' }
      },
      {
        path: 'register-record',
        component: () => import('@/views/distribution/register-record'), //  Parent router-view
        name: 'DestributionRegisterRecord',
        meta: { title: '注册分销记录' }
      },
      {
        path: 'distributor-examine',
        component: () => import('@/views/distribution/distributor-examine'), //  Parent router-view
        name: 'DistributorExamine',
        meta: { title: '审核分销商' }
      },
      {
        path: 'team-index',
        component: () => import('@/views/distribution/team/index'), //  Parent router-view
        name: 'DistributorTeamIndex',
        meta: { title: '团队业绩' }
      }
    ]
  },
  // 商圈管理
  {
    path: '/business',
    component: Layout,
    redirect: '/business/index',
    name: 'Business',
    meta: {
      title: '商圈管理',
      icon: 'nested'
    },
    children: [
      {
        path: 'index',
        name: 'BusinessDistrict',
        component: () => import('@/views/business/index'),
        meta: { title: '商圈管理', icon: 'form' }
      },
      {
        path: 'eidt-business-district',
        name: 'EditBusinessDistrict',
        component: () => import('@/views/business/eidt-business-district'),
        meta: { title: '新增商圈', icon: 'form' }
      }
    ]
  },
  // 供应商管理
  {
    path: '/supplier',
    component: Layout,
    redirect: '/supplier/index',
    name: 'Supplier',
    meta: {
      title: '供应商管理',
      icon: 'nested'
    },
    children: [
      {
        path: 'index',
        name: 'SupplierBusiness',
        component: () => import('@/views/supplier/index'),
        meta: { title: '供应商管理', icon: 'form' }
      },
      {
        path: 'eidt',
        name: 'EditSupplier',
        component: () => import('@/views/supplier/edit'),
        meta: { title: '新增供应商', icon: 'form' }
      },
      {
        path: 'shop',
        name: 'SupplierShop',
        component: () => import('@/views/supplier/shop'),
        meta: { title: '供应商门店', icon: 'form' }
      },
      {
        path: 'edit-shop',
        name: 'EditSupplierShop',
        component: () => import('@/views/supplier/edit-shop'),
        meta: { title: '新增供应商门店', icon: 'form' }
      },
      {
        path: 'withdrawal',
        component: () => import('@/views/supplier/withdrawal'), //  Parent router-view
        name: 'SupplierWithdrawal',
        meta: { title: '提现申请记录' }
      },
      {
        path: 'chain',
        component: () => import('@/views/supplier/chain'), //  Parent router-view
        name: 'SupplierChain',
        meta: { title: '连锁品牌模式' }
      },
      {
        path: 'chain-edit',
        component: () => import('@/views/supplier/chain/edit'), //  Parent router-view
        name: 'SupplierChainEdit',
        meta: { title: '创建连锁品牌' }
      }
    ]
  },
  // 评价管理
  {
    path: '/evaluate',
    component: Layout,
    redirect: '/evaluate/index',
    name: 'Evaluate',
    meta: {
      title: '评价管理',
      icon: 'nested'
    },
    children: [
      {
        path: 'index',
        name: 'Evaluate',
        component: () => import('@/views/evaluate/index'),
        meta: { title: '评价管理', icon: 'form' }
      }
    ]
  },
  // 检查表管理
  {
    path: '/inspection',
    component: Layout,
    redirect: '/inspection/index',
    name: 'Inspection',
    meta: { title: '检查表管理', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'InspectionIndex',
        component: () => import('@/views/inspection/index'),
        meta: { title: '检查表列表', icon: 'eye' }
      },
      {
        path: 'add',
        name: 'InspectionEdit',
        component: () => import('@/views/inspection/add'),
        meta: { title: '新增检查表', icon: 'eye' }
      }
    ]
  },
  // 任务表管理
  {
    path: '/task',
    component: Layout,
    redirect: '/task/index',
    name: 'Task',
    meta: { title: '任务表管理', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'TaskIndex',
        component: () => import('@/views/task/index'),
        meta: { title: '任务表列表', icon: 'eye' }
      },
      {
        path: 'add',
        name: 'TaskEdit',
        component: () => import('@/views/task/add'),
        meta: { title: '新增任务表', icon: 'eye' }
      }
    ]
  },
  // 活动管理
  {
    path: '/activity-manage',
    component: Layout,
    redirect: '/activity-manage/index',
    name: 'ActivityManage',
    meta: { title: '活动管理', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'ActivityManageIndex',
        component: () => import('@/views/activity-manage/index'),
        meta: { title: '活动管理', icon: 'eye' }
      },
      {
        path: 'edit-activity',
        name: 'EditActivity',
        component: () => import('@/views/activity-manage/edit-activity'),
        meta: { title: '新增活动', icon: 'eye' }
      }
    ]
  },
  // 嘉宾
  {
    path: '/guest',
    component: Layout,
    redirect: '/guest/index',
    name: 'Guest',
    meta: { title: '嘉宾', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'GuestIndex',
        component: () => import('@/views/guest/index'),
        meta: { title: '嘉宾列表', icon: 'eye' }
      },
      {
        path: 'edit',
        name: 'GuestEdit',
        component: () => import('@/views/guest/edit'),
        meta: { title: '编辑嘉宾', icon: 'eye' }
      }
    ]
  },
  // 获客管理
  {
    path: '/customer',
    component: Layout,
    redirect: '/customer/video/index',
    name: 'Customer',
    meta: { title: '获客管理', icon: 'example' },
    children: [
      {
        path: 'video/index',
        name: 'VideoIndex',
        component: () => import('@/views/customer/video/index'),
        meta: { title: '视频内容', icon: 'eye' }
      },
      {
        path: 'video/edit',
        name: 'VideoEdit',
        component: () => import('@/views/customer/video/edit'),
        meta: { title: '新增视频内容', icon: 'eye' }
      },
      {
        path: 'case/index',
        name: 'CaseIndex',
        component: () => import('@/views/customer/case/index'),
        meta: { title: '案例内容', icon: 'eye' }
      },
      {
        path: 'case/edit',
        name: 'CaseEdit',
        component: () => import('@/views/customer/case/edit'),
        meta: { title: '新增案例内容', icon: 'eye' }
      },
      {
        path: 'case/type',
        name: 'CaseType',
        component: () => import('@/views/customer/case/type'),
        meta: { title: '类型管理', icon: 'eye' }
      },
      {
        path: 'pop/index',
        name: 'PopIndex',
        component: () => import('@/views/customer/pop/index'),
        meta: { title: '弹出商品', icon: 'eye' }
      },
      {
        path: 'notice/index',
        name: 'NoticeIndex',
        component: () => import('@/views/customer/notice/index'),
        meta: { title: '公告管理', icon: 'eye' }
      },
      {
        path: 'share/index',
        name: 'ShareIndex',
        component: () => import('@/views/customer/share/index'),
        meta: { title: '分享榜', icon: 'eye' }
      },
      {
        path: 'share/edit',
        name: 'ShareEdit',
        component: () => import('@/views/customer/share/edit'),
        meta: { title: '创建分享活动', icon: 'eye' }
      },
      {
        path: 'share/record',
        name: 'ShareRecord',
        component: () => import('@/views/customer/share/record'),
        meta: { title: '中奖记录', icon: 'eye' }
      }
    ]
  },
  // 同城寻宝
  {
    path: '/treasure',
    component: Layout,
    redirect: '/treasure/activity/index',
    name: 'Treasure',
    meta: { title: '同城寻宝', icon: 'example' },
    children: [
      {
        path: 'activity/index',
        name: 'TreasureIndex',
        component: () => import('@/views/treasure/activity/index'),
        meta: { title: '活动列表', icon: 'eye' }
      },
      {
        path: 'activity/edit',
        name: 'TreasureEdit',
        component: () => import('@/views/treasure/activity/edit'),
        meta: { title: '添加活动', icon: 'eye' }
      },
      {
        path: 'sponsor/index',
        name: 'SponsorIndex',
        component: () => import('@/views/treasure/sponsor/index'),
        meta: { title: '赞助商', icon: 'eye' }
      },
      {
        path: 'sponsor/edit',
        name: 'SponsorEdit',
        component: () => import('@/views/treasure/sponsor/edit'),
        meta: { title: '添加赞助商', icon: 'eye' }
      },
      {
        path: 'denominator/index',
        name: 'DenominatorIndex',
        component: () => import('@/views/treasure/denominator/index'),
        meta: { title: '冠名商', icon: 'eye' }
      },
      {
        path: 'denominator/edit',
        name: 'DenominatorEdit',
        component: () => import('@/views/treasure/denominator/edit'),
        meta: { title: '添加冠名商', icon: 'eye' }
      },
      {
        path: 'packet/index',
        name: 'PacketIndex',
        component: () => import('@/views/treasure/packet/index'),
        meta: { title: '红包列表', icon: 'eye' }
      },
      {
        path: 'packet/edit',
        name: 'PacketEdit',
        component: () => import('@/views/treasure/packet/edit'),
        meta: { title: '添加红包', icon: 'eye' }
      }
    ]
  },

  // **************************高校新增菜单START*********************************
  // 首页
  {
    path: '/college/home',
    component: Layout,
    redirect: '/college/home/index',
    name: 'CollegeHome',
    children: [
      {
        path: 'index',
        name: 'CollegeHomeIndex',
        component: () => import('@/views/college/home/index'),
        meta: { title: '首页', icon: 'eye' }
      }
    ]
  },
  // 公司统计
  {
    path: '/college/company',
    component: Layout,
    // redirect: '/college/system/company/profit',
    name: 'CollegeHome',
    meta: { title: '公司相关', icon: 'example' },
    children: [
      {
        path: 'withdrawal',
        name: 'CollegeWithdrawalIndex',
        component: () => import('@/views/college/withdrawal/index'),
        meta: { title: '提现记录', icon: 'eye' }
      },
      {
        path: 'statistics',
        name: 'CollegeReserveCompany',
        component: () => import('@/views/college/reserve/company-statistics'),
        meta: { title: '公司抽成', icon: 'eye' }
      },
      {
        path: 'profit',
        name: 'collegeCompanyProfit',
        component: () => import('@/views/system/company/profit'),
        meta: { title: '公司收益', icon: 'eye' }
      },
      {
        path: 'account-set',
        name: 'collegeCompanyAccountSet',
        component: () => import('@/views/system/company/account-set'),
        meta: { title: '账户配置', icon: 'eye' }
      }
    ]
  },
  // 系统
  {
    path: '/college/system',
    component: Layout,
    redirect: '/college/system/index',
    name: 'CollegeHome',
    meta: { title: '系统模块', icon: 'example' },
    children: [
      {
        path: 'brand/index',
        name: 'collegeBrandIndex',
        component: () => import('@/views/system/brand/index'),
        meta: { title: '站点信息', icon: 'eye' }
      },
      {
        path: 'brand/distribution',
        name: 'collegeBrandDistribution',
        component: () => import('@/views/system/brand/distribution'),
        meta: { title: '配送设置', icon: 'eye' }
      },
      {
        path: 'brand/account-set',
        name: 'collegeBrandAccountSet',
        component: () => import('@/views/system/brand/account-set'),
        meta: { title: '出入账号设置', icon: 'eye' }
      },
      {
        path: 'building/index',
        name: 'collegeBuildingIndex',
        component: () => import('@/views/college/building/index'),
        meta: { title: '楼栋管理', icon: 'eye' }
      },
      {
        path: 'service-index',
        name: 'collegeServiceIndex',
        component: () => import('@/views/college/service/index'),
        meta: { title: '在线客服设置', icon: 'eye' }
      },
      {
        path: 'service-list',
        name: 'collegeServiceList',
        component: () => import('@/views/college/service/service-list'),
        meta: { title: '客服管理', icon: 'eye' }
      },
      {
        path: 'service-reply',
        name: 'collegeServiceReply',
        component: () => import('@/views/college/service/reply'),
        meta: { title: '回复设置', icon: 'eye' }
      },
      {
        path: 'shop/index',
        name: 'collegeShopIndex',
        component: () => import('@/views/system/shop/index'),
        meta: { title: '店铺管理', icon: 'eye' }
      },
      {
        path: 'shop/edit',
        name: 'collegeShopEdit',
        component: () => import('@/views/system/shop/edit'),
        meta: { title: '编辑店铺信息', icon: 'eye' }
      },
      {
        path: 'shop/distribution',
        name: 'collegeShopDistribution',
        component: () => import('@/views/system/shop/distribution'),
        meta: { title: '配送设置', icon: 'eye' }
      },
      {
        path: 'shop/account-set',
        name: 'collegeShopAccountSet',
        component: () => import('@/views/system/shop/account-set'),
        meta: { title: '收银设置', icon: 'eye' }
      },
      {
        path: 'shop/print-configuration',
        name: 'collegePrintConfiguration',
        component: () => import('@/views/system/shop/print-configuration'),
        meta: { title: '打印配置', icon: 'eye' }
      },
      {
        path: 'staff-list',
        name: 'CollegeShopStaffList',
        component: () => import('@/views/college/permission/staff-list'),
        meta: { title: '员工管理', icon: 'eye' }
      },
      {
        path: 'edit-staff',
        name: 'CollegeShopEditStaff',
        component: () => import('@/views/college/permission/edit-staff'),
        meta: { title: '添加员工', icon: 'eye' }
      },
      {
        path: 'edit-role',
        name: 'CollegeShopEditRole',
        component: () => import('@/views/college/permission/edit-role'),
        meta: { title: '角色管理', icon: 'eye' }
      },
      {
        path: 'edit-role-permission',
        name: 'CollegeRolePermission',
        component: () =>
          import('@/views/college/permission/edit-role-permission'),
        meta: { title: '权限设置', icon: 'eye' }
      },
      {
        path: 'edit-express-template',
        name: 'CollegeShopEditExpressTemplate',
        component: () => import('@/views/system/shop/logistics/edit'),
        meta: { title: '创建快递模板', icon: 'eye' }
      },
      {
        path: 'operate-score',
        name: 'CollegeOperateScore',
        component: () => import('@/views/college/operate/score'),
        meta: { title: '站点运营分', icon: 'eye' }
      }
    ]
  },
  // 副站权限
  {
    path: '/college/permission',
    component: Layout,
    redirect: '/college/permission/staff-list',
    name: 'CollegeHome',
    meta: { title: '副站权限', icon: 'example' },
    children: [
      {
        path: 'staff-list',
        name: 'CollegeStaffList',
        component: () => import('@/views/college/permission/staff-list'),
        meta: { title: '副站长管理', icon: 'eye' }
      },
      {
        path: 'edit-staff',
        name: 'CollegeEditStaff',
        component: () => import('@/views/college/permission/edit-staff'),
        meta: { title: '添加员工', icon: 'eye' }
      },
      {
        path: 'edit-role',
        name: 'CollegeEditRole',
        component: () => import('@/views/college/permission/edit-role'),
        meta: { title: '角色管理', icon: 'eye' }
      },
      {
        path: 'role-permission',
        name: 'CollegeRolePermission',
        component: () =>
          import('@/views/college/permission/edit-role-permission'),
        meta: { title: '权限设置', icon: 'eye' }
      },
      {
        path: 'role-notice',
        name: 'CollegeRoleNotice',
        component: () => import('@/views/college/permission/notice'),
        meta: { title: '通知设置', icon: 'eye' }
      }
    ]
  },
  // 站点配置
  {
    path: '/college/site',
    component: Layout,
    redirect: '/college/site/index',
    meta: { title: '站点配置', icon: 'example' },
    children: [
      {
        path: 'decoration/index',
        name: 'CollegeDecorationIndex',
        component: () => import('@/views/system/decoration/index'),
        meta: { title: '首页配置', icon: 'eye' }
      },
      {
        path: 'shop/index',
        name: 'collegeBrandShopIndex',
        component: () => import('@/views/system/shop/index'),
        meta: { title: '店铺管理', icon: 'eye' }
      },
      {
        path: 'shop/edit',
        name: 'collegeBrandShopEdit',
        component: () => import('@/views/system/shop/edit'),
        meta: { title: '编辑店铺信息', icon: 'eye' }
      },
      {
        path: 'shop/distribution',
        name: 'collegeBrandShopDistribution',
        component: () => import('@/views/system/shop/distribution'),
        meta: { title: '配送设置', icon: 'eye' }
      },
      {
        path: 'shop/account-set',
        name: 'collegeBrandShopAccountSet',
        component: () => import('@/views/system/shop/account-set'),
        meta: { title: '收银设置', icon: 'eye' }
      },
      {
        path: 'shop/print-configuration',
        name: 'collegeBrandPrintConfiguration',
        component: () => import('@/views/system/shop/print-configuration'),
        meta: { title: '打印配置', icon: 'eye' }
      },
      {
        path: 'account',
        name: 'CollegeGroupAccount',
        component: () => import('@/views/college/group/account'),
        meta: { title: '集团账户管理', icon: 'eye' }
      },
      // {
      //   path: 'logistics-settings',
      //   name: 'CollegeLogisticsSettings',
      //   component: () => import('@/views/system/shop/logistics/index'),
      //   meta: { title: '物流设置', icon: 'eye' }
      // },
      {
        path: 'edit-express-template',
        name: 'CollegeEditExpressTemplate',
        component: () => import('@/views/system/shop/logistics/edit'),
        meta: { title: '创建快递模板', icon: 'eye' }
      }
    ]
  },
  // 信息发布——删除
  {
    path: '/information',
    component: Layout,
    redirect: '/information/index',
    name: 'Information',
    meta: { title: '信息发布', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'InformationIndex2',
        component: () => import('@/views/college/information/index'),
        meta: { title: '信息列表', icon: 'eye' }
      },
      {
        path: 'type-list',
        name: 'InformationTypeList2',
        component: () => import('@/views/college/information/type-list'),
        meta: { title: '分类设置', icon: 'eye' }
      }
    ]
  },
  // 论坛
  {
    path: '/forum',
    component: Layout,
    redirect: '/forum/index',
    name: 'Forum',
    meta: { title: '论坛', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'ForumIndex',
        component: () => import('@/views/forum/index'),
        meta: { title: '论坛列表', icon: 'eye' }
      },
      {
        path: 'type-list',
        name: 'ForumTypeList',
        component: () => import('@/views/forum/type-list'),
        meta: { title: '分类设置', icon: 'eye' }
      }
    ]
  },
  // 储备金——财务管理
  {
    path: '/college/reserve',
    component: Layout,
    // redirect: '/college/reserve/index',
    name: 'CollegeReserve',
    meta: { title: '财务管理', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'CollegeReserveIndex',
        component: () => import('@/views/college/reserve/index'),
        meta: { title: '站长收支', icon: 'eye' }
      },
      {
        path: 'brand',
        name: 'CollegeReserveBrand',
        component: () => import('@/views/college/reserve/brand-statistics'),
        meta: { title: '店铺储备金', icon: 'eye' }
      },
      // {
      //   path: 'shop',
      //   name: 'CollegeReserveShop',
      //   component: () => import('@/views/college/reserve/shop-statistics'),
      //   meta: { title: '店铺储备金', icon: 'eye' }
      // },
      {
        path: 'company',
        name: 'CollegeReserveCompany',
        component: () => import('@/views/college/reserve/company-statistics'),
        meta: { title: '公司抽成', icon: 'eye' }
      },
      {
        path: 'balance',
        name: 'CollegeReserveBalance',
        component: () => import('@/views/college/reserve/balance'),
        meta: { title: '余额', icon: 'eye' }
      },
      // {
      //   path: 'management',
      //   name: 'CollegeReserveManagement',
      //   component: () => import('@/views/college/reserve/management'),
      //   meta: { title: '储备金管理', icon: 'eye' }
      // },
      {
        path: 'platform',
        name: 'CollegeReservePlatform',
        component: () => import('@/views/college/reserve/platform'),
        meta: { title: '集团储备金', icon: 'eye' }
      },
      // {
      //   path: 'group-shop',
      //   name: 'CollegeReserveGroupShop',
      //   component: () =>
      //     import('@/views/college/reserve/group-shop-statistics'),
      //   meta: { title: '门店储备金', icon: 'eye' }
      // },
      // {
      //   path: 'details',
      //   name: 'CollegeReserveGroupDetails',
      //   component: () => import('@/views/college/reserve/details'),
      //   meta: { title: '储备金明细', icon: 'eye' }
      // },
      {
        path: 'account-statistics',
        name: 'CollegeReserveAccountStatistics',
        component: () => import('@/views/college/reserve/account-statistics'),
        meta: { title: '出入账统计', icon: 'eye' }
      },
      {
        path: 'ledger-record',
        name: 'CollegeReserveLedgerRecord',
        component: () => import('@/views/college/reserve/ledger-record'),
        meta: { title: '站长分账', icon: 'eye' }
      },

      // 转移到公司相关菜单下
      {
        path: 'withdrawal',
        name: 'CollegeWithdrawalIndex',
        component: () => import('@/views/college/withdrawal/index'),
        meta: { title: '提现记录', icon: 'eye' }
      }
    ]
  },
  {
    path: '/college/reserve',
    component: Layout,
    // redirect: '/college/reserve/index',
    name: 'CollegeReserve',
    meta: { title: '储备金', icon: 'example' },
    children: [
      {
        path: 'management',
        name: 'CollegeReserveManagement',
        component: () => import('@/views/college/reserve/management'),
        meta: { title: '储备金管理', icon: 'eye' }
      },
      {
        path: 'details',
        name: 'CollegeReserveGroupDetails',
        component: () => import('@/views/college/reserve/details'),
        meta: { title: '储备金明细', icon: 'eye' }
      },
      {
        path: 'shop',
        name: 'CollegeReserveShop',
        component: () => import('@/views/college/reserve/shop-statistics'),
        meta: { title: '店铺储备金', icon: 'eye' }
      },
      {
        path: 'group-shop',
        name: 'CollegeReserveGroupShop',
        component: () =>
          import('@/views/college/reserve/group-shop-statistics'),
        meta: { title: '门店储备金', icon: 'eye' }
      },
      {
        path: 'account-statistics',
        name: 'CollegeReserveAccountStatistics',
        component: () => import('@/views/college/reserve/account-statistics'),
        meta: { title: '出入账统计', icon: 'eye' }
      },
      {
        path: 'shop-ledger-record',
        name: 'CollegeReserveShopLedgerRecord',
        component: () => import('@/views/college/reserve/ledger-record'),
        meta: { title: '分账记录', icon: 'eye' }
      },
      {
        path: 'group-ledger-record',
        name: 'CollegeReserveGroupLedgerRecord',
        component: () => import('@/views/college/reserve/ledger-record'),
        meta: { title: '集团分账', icon: 'eye' }
      }
    ]
  },
  // 应用
  {
    path: '/college/application',
    component: Layout,
    redirect: '/college/application/index',
    name: 'CollegeApplication',
    meta: { title: '应用', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'CollegeApplicationIndex',
        component: () => import('@/views/college/application/index'),
        meta: { title: '应用列表', icon: 'eye' }
      },
      {
        path: 'running-errands',
        name: 'RunningErrands',
        component: () => import('@/views/college/application/running/index'),
        meta: { title: '骑手接单', icon: 'form' }
      },
      {
        path: 'movie/index',
        name: 'CollegeApplicationMovieIndex',
        component: () => import('@/views/college/application/movie/index'),
        meta: { title: '电影票', icon: 'form' }
      },
      {
        path: 'movie-setting',
        name: 'CollegeMovieSetting',
        component: () =>
          import('@/views/college/application/movie/movie-setting'),
        meta: { title: '电影票设置', icon: 'form' }
      },
      {
        path: 'package-fee-setting',
        name: 'CollegePackageFeeSetting',
        component: () => import('@/views/college/application/package/index'),
        meta: { title: '打包费设置', icon: 'form' }
      },
      {
        path: 'confession',
        name: 'ConfessionIndex',
        component: () => import('@/views/college/confession/index'),
        meta: { title: '表白墙列表', icon: 'eye' }
      },
      {
        path: 'type-list',
        name: 'ConfessionTypeList',
        component: () => import('@/views/college/confession/type-list'),
        meta: { title: '分类设置', icon: 'eye' }
      },
      {
        path: 'errand-service',
        name: 'ErranServiceIndex',
        component: () => import('@/views/errand-service/index'),
        meta: { title: '跑腿服务', icon: 'eye' }
      },
      {
        path: 'express',
        name: 'CollegeExpressIndex',
        component: () => import('@/views/college/express/index'),
        meta: { title: '快递代取', icon: 'eye' }
      },
      {
        path: 'express-places',
        name: 'CollegeExpressPlaces',
        component: () => import('@/views/college/express/express-places'),
        meta: { title: '快递点设置', icon: 'eye' }
      },
      {
        path: 'city-express-rule',
        name: 'CollegeCityExpressRule',
        component: () => import('@/views/college/express/city/rule'),
        meta: { title: '规则设置', icon: 'eye' }
      },
      {
        path: 'information',
        name: 'InformationIndex',
        component: () => import('@/views/college/information/index'),
        meta: { title: '信息发布', icon: 'eye' }
      },
      {
        path: 'information-type-list',
        name: 'InformationTypeList',
        component: () => import('@/views/college/information/type-list'),
        meta: { title: '分类设置', icon: 'eye' }
      },
      {
        path: 'takeout/index',
        name: 'CollegeTakeOutIndex',
        component: () => import('@/views/college/application/takeout/index'),
        meta: { title: 'CPS红包', icon: 'form' }
      },
      {
        path: 'red-packet-setting',
        name: 'CollegeRedPacketSetting',
        component: () =>
          import('@/views/college/application/takeout/red-packet-setting'),
        meta: { title: 'CPS红包规则', icon: 'form' }
      },
      {
        path: 'friend-setting',
        name: 'CollegeFriendSetting',
        component: () => import('@/views/college/application/friend/index'),
        meta: { title: '同城交友', icon: 'form' }
      },
      {
        path: 'appointmentExpress',
        name: 'appointmentExpressIndex',
        component: () => import('@/views/college/appointmentExpress/index'),
        meta: { title: '预约寄取', icon: 'eye' }
      },
      {
        path: 'sounds',
        name: 'CollegeSounds',
        component: () => import('@/views/college/application/sounds/index'),
        meta: { title: '送达语音通知', icon: 'eye' }
      }
    ]
  },
  // 营销
  {
    path: '/college/marketing',
    component: Layout,
    redirect: '/college/marketing/index',
    name: 'CollegeMarketing',
    meta: { title: '营销推广', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'CollegeMarketingIndex',
        component: () => import('@/views/college/marketing/index'),
        meta: { title: '营销列表', icon: 'eye' }
      },
      {
        path: 'coupon-List',
        name: 'CollegeCouponList',
        component: () => import('@/views/college/marketing/coupon/index'),
        meta: { title: '优惠券', icon: 'eye' }
      },
      {
        path: 'edit-coupon',
        name: 'CollegeEditCoupon',
        component: () => import('@/views/college/marketing/coupon/edit'),
        meta: { title: '添加优惠券', icon: 'eye' }
      },
      {
        path: 'ticket-statistics',
        name: 'CollegeTicketStatistics',
        component: () =>
          import('@/views/college/marketing/coupon/ticket-statistics'),
        meta: { title: '优惠券使用统计', icon: 'eye' }
      },
      {
        path: 'register-present',
        name: 'CollegeRegisterPresent',
        component: () => import('@/views/college/marketing/register/index'),
        meta: { title: '注册礼', icon: 'eye' }
      },
      {
        path: 'edit-register-present',
        name: 'CollegeEditRegisterPresent',
        component: () => import('@/views/college/marketing/register/edit'),
        meta: { title: '创建注册礼活动', icon: 'eye' }
      },
      {
        path: 'self-system-form',
        name: 'CollegeSelfSystemForm',
        component: () => import('@/views/college/marketing/form/index'),
        meta: { title: '自定义系统表单', icon: 'eye' }
      },
      {
        path: 'edit-system-form',
        name: 'CollegeSelfSystemFormEdit',
        component: () => import('@/views/college/marketing/form/edit'),
        meta: { title: '编辑自定义系统表单', icon: 'eye' }
      },
      {
        path: 'order-reward',
        name: 'CollegeOrderReward',
        component: () => import('@/views/college/marketing/order-reward/index'),
        meta: { title: '下单奖励', icon: 'eye' }
      },
      {
        path: 'order-reward-edit',
        name: 'CollegeOrderRewardEdit',
        component: () => import('@/views/college/marketing/order-reward/edit'),
        meta: { title: '新增下单奖励', icon: 'eye' }
      },
      {
        path: 'big-turntable',
        name: 'CollegeBigTurntable',
        component: () => import('@/views/college/marketing/turntable/index'),
        meta: { title: '大转盘', icon: 'eye' }
      },
      {
        path: 'big-turntable-edit',
        name: 'CollegeBigTurntableEdit',
        component: () => import('@/views/college/marketing/turntable/edit'),
        meta: { title: '新增大转盘', icon: 'eye' }
      },
      {
        path: 'assistance-index',
        name: 'CollegeWechatAssistance',
        component: () => import('@/views/college/marketing/assistance/index'),
        meta: { title: '微助力', icon: 'eye' }
      },
      {
        path: 'assistance-edit',
        name: 'CollegeEditWechatAssistance',
        component: () => import('@/views/college/marketing/assistance/edit'),
        meta: { title: '微助力', icon: 'eye' }
      },
      {
        path: 'sms-marketing',
        name: 'CollegeSMSMarketing',
        component: () => import('@/views/college/marketing/sms/index'),
        meta: { title: '短信', icon: 'eye' }
      },
      {
        path: 'precision-marketing',
        name: 'CollegePrecisionMarketing',
        component: () => import('@/views/college/marketing/precision/index'),
        meta: { title: '精准营销', icon: 'eye' }
      },
      {
        path: 'edit-precision-marketing',
        name: 'CollegeEditPrecisionMarketing',
        component: () => import('@/views/college/marketing/precision/edit'),
        meta: { title: '创建精准营销活动', icon: 'eye' }
      },
      {
        path: 'effective',
        name: 'CollegeMarketEffective',
        component: () => import('@/views/college/marketing/effective/index'),
        meta: { title: '时效卡', icon: 'eye' }
      },
      {
        path: 'effective/edit',
        name: 'CollegeMarketEffectiveEdit',
        component: () => import('@/views/college/marketing/effective/edit'),
        meta: { title: '编辑时效卡', icon: 'eye' }
      },
      {
        path: 'effective/record',
        name: 'CollegeMarketEffectiveERecord',
        component: () => import('@/views/college/marketing/effective/record'),
        meta: { title: '时效卡开通记录', icon: 'eye' }
      },
      {
        path: 'effective/setting',
        name: 'CollegeMarketEffectiveSetting',
        component: () => import('@/views/college/marketing/effective/setting'),
        meta: { title: '时效卡', icon: 'eye' }
      }
    ]
  },
  // 骑手——校园专送
  {
    path: '/college/waiter',
    component: Layout,
    redirect: '/waiter/service-mgmt',
    name: 'CollegeWaiter',
    meta: { title: '校园专送', icon: 'example' },
    children: [
      {
        path: 'service-mgmt',
        component: () => import('@/views/college/waiter/service-mgmt'),
        name: 'CollegeServiceMgmt',
        meta: { title: '骑手管理' }
      },
      {
        path: 'waiter-mgmt',
        component: () => import('@/views/college/waiter/waiter-mgmt'),
        name: 'CollegeWaiterMgmt',
        meta: { title: '添加骑手' }
      },
      {
        path: 'group-mgmt',
        component: () => import('@/views/college/waiter/group-mgmt'),
        name: 'CollegeGroupMgmt',
        meta: { title: '分组管理' }
      },
      {
        path: 'achievement-statistics',
        name: 'AchievementStatistics',
        component: () => import('@/views/college/waiter/achievement'),
        meta: { title: '骑手业绩明细', icon: 'eye' }
      }
    ]
  },
  // 兼职广场
  {
    path: '/college/sideline',
    component: Layout,
    redirect: '/college/sideline/enterprise',
    name: 'CollegeSideline',
    meta: { title: '兼职广场', icon: 'example' },
    children: [
      {
        path: 'enterprise',
        name: 'CollegeSidelineEnterprise',
        component: () => import('@/views/college/sideline/enterprise'),
        meta: { title: '兼职招聘企业', icon: 'eye' }
      },
      {
        path: 'roster',
        name: 'CollegeSidelineRoster',
        component: () => import('@/views/college/sideline/roster'),
        meta: { title: '兼职登记名单', icon: 'eye' }
      },
      {
        path: 'post',
        name: 'CollegeSidelinePost',
        component: () => import('@/views/college/sideline/post'),
        meta: { title: '兼职岗位信息', icon: 'eye' }
      }
    ]
  },
  // 提现记录——删除
  {
    path: '/college/withdrawal',
    component: Layout,
    redirect: '/college/withdrawal/index',
    name: 'CollegeWithdrawal',
    // meta: { title: '兼职广场', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'CollegeWithdrawalIndex',
        component: () => import('@/views/college/withdrawal/index'),
        meta: { title: '提现记录', icon: 'eye' }
      }
    ]
  },
  // 集团
  {
    path: '/college/group',
    component: Layout,
    redirect: '/college/group/account',
    name: 'CollegeGroup',
    meta: { title: '集团', icon: 'example' },
    children: [
      {
        path: 'account',
        name: 'CollegeGroupAccount2',
        component: () => import('@/views/college/group/account'),
        meta: { title: '集团账户', icon: 'eye' }
      },
      {
        path: 'account-set',
        name: 'CollegeGroupAccountSet',
        component: () => import('@/views/college/group/account-set'),
        meta: { title: '集团配置', icon: 'eye' }
      },
      {
        path: 'order',
        name: 'CollegeGroupOrder',
        component: () => import('@/views/college/group/order-mgmt'),
        meta: { title: '订单管理', icon: 'eye' }
      },
      {
        path: 'service-charge',
        name: 'CollegeGroupServiceCharge',
        component: () => import('@/views/college/group/service-charge'),
        meta: { title: '集团服务费', icon: 'eye' }
      }
    ]
  },
  // 集团——店铺管理
  {
    path: '/college/group/shop',
    component: Layout,
    // redirect: '/college/group/shop/',
    name: 'CollegeWithdrawal',
    meta: { title: '店铺管理', icon: 'example' },
    children: [
      {
        path: 'shop-mgmt',
        name: 'CollegeGroupShopMgmt',
        component: () => import('@/views/college/group/shop/shop-mgmt'),
        meta: { title: '店铺列表', icon: 'eye' }
      },
      {
        path: 'balance',
        name: 'CollegeGroupBalanceRecord',
        component: () => import('@/views/college/group/shop/balance-record'),
        meta: { title: '余额提现记录', icon: 'eye' }
      }
    ]
  },
  // 在线客服——删除
  {
    path: '/college/service',
    component: Layout,
    redirect: '/college/service/index',
    name: 'Service',
    // meta: { title: '测试', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'collegeServiceIndex2',
        component: () => import('@/views/college/service/index'),
        meta: { title: '在线客服', icon: 'eye' }
      },
      {
        path: 'service-list',
        name: 'collegeServiceList2',
        component: () => import('@/views/college/service/service-list'),
        meta: { title: '客服管理', icon: 'eye' }
      },
      {
        path: 'reply',
        name: 'collegeServiceReply2',
        component: () => import('@/views/college/service/reply'),
        meta: { title: '回复设置', icon: 'eye' }
      }
    ]
  },
  // 全民跑腿——删除
  {
    path: '/errand-service',
    component: Layout,
    redirect: '/errand-service/index',
    name: 'ErranService',
    meta: { title: '全民跑腿', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'ErranServiceIndex2',
        component: () => import('@/views/errand-service/index'),
        meta: { title: '全民跑腿', icon: 'eye' }
      }
    ]
  },
  // 代取快递——删除
  {
    path: '/college/express',
    component: Layout,
    redirect: '/college/express/index',
    name: 'CollegeExpress',
    meta: { title: '快递代取', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'CollegeExpressIndex2',
        component: () => import('@/views/college/express/index'),
        meta: { title: '快递代取', icon: 'eye' }
      },
      {
        path: 'express-places',
        name: 'CollegeExpressPlaces2',
        component: () => import('@/views/college/express/express-places'),
        meta: { title: '快递点设置', icon: 'eye' }
      }
    ]
  },
  // 订单
  {
    path: '/college/order',
    component: Layout,
    // redirect: '/college/order/index',
    name: 'CollegeExpress',
    meta: { title: '订单管理', icon: 'example' },
    children: [
      {
        path: 'order-mgmt',
        name: 'CollegeOrderMgmt',
        component: () => import('@/views/college/order/order-mgmt'),
        meta: { title: '外卖订单管理', icon: 'eye' }
      },
      {
        path: 'transaction-settings',
        name: 'CollegeOrderSettings',
        component: () => import('@/views/college/order/transaction-settings'),
        meta: { title: '规则设置', icon: 'eye' }
      },
      {
        path: 'evaluation',
        name: 'CollegeOrderEvaluation',
        component: () => import('@/views/college/order/evaluation/index'),
        meta: { title: '订单评价', icon: 'eye' }
      },
      {
        path: 'evaluation-tag',
        name: 'CollegeOrderEvaluationTag',
        component: () => import('@/views/college/order/evaluation/tag'),
        meta: { title: '订单标签管理', icon: 'eye' }
      },
      {
        path: 'typing-group',
        name: 'CollegeGoodsTypingGroup',
        component: () => import('@/views/goods/college/tying-group'),
        meta: { title: '搭售分组', icon: 'eye' }
      }
    ]
  },
  // 会员
  {
    path: '/college/user',
    component: Layout,
    redirect: 'college/user/user-list',
    name: 'CollegeUser',
    meta: { title: '会员', icon: 'example' },
    children: [
      {
        path: 'user-list',
        name: 'CollegeUserList',
        component: () => import('@/views/college/user/user-list'),
        meta: { title: '会员列表', icon: 'eye' }
      },
      {
        path: 'edit-user',
        name: 'CollegeEditUser',
        component: () => import('@/views/college/user/edit-user'),
        meta: { title: '会员详情', icon: 'eye' }
      },
      {
        path: 'user-tags',
        name: 'CollegeUserTags',
        component: () => import('@/views/college/user/user-tags'),
        meta: { title: '标签管理', icon: 'eye' }
      },
      {
        path: 'expand-information',
        name: 'CollegeExpandInfomation',
        component: () => import('@/views/college/user/expand-information'),
        meta: { title: '会员拓展信息', icon: 'eye' }
      },
      {
        path: 'user-grade',
        name: 'CollegeUserGrade',
        component: () => import('@/views/college/user/user-grade'),
        meta: { title: '会员等级', icon: 'eye' }
      },
      {
        path: 'edit-grade',
        name: 'CollegeEditGrade',
        component: () => import('@/views/college/user/edit-grade'),
        meta: { title: '新增会员等级', icon: 'eye' }
      },
      {
        path: 'grade-rule',
        name: 'CollegeGradeRule',
        component: () => import('@/views/college/user/grade-rule'),
        meta: { title: '等级规则', icon: 'eye' }
      },
      {
        path: 'change-site',
        name: 'CollegeChangeSite',
        component: () => import('@/views/college/user/change/index'),
        meta: { title: '站点修改审核', icon: 'eye' }
      }
    ]
  },
  // 财务统计
  {
    path: '/college/statistics',
    component: Layout,
    redirect: '/college/statistics/order-statistics',
    name: 'CollegeStatistics',
    meta: { title: '财务统计', icon: 'example' },
    children: [
      {
        path: 'order-statistics',
        name: 'CollegeStatisticsOrder',
        component: () => import('@/views/college/statistics/order-statistics'),
        meta: { title: '订单统计', icon: 'eye' }
      },
      {
        path: 'goods-statistics',
        name: 'CollegeStatisticsGoods',
        component: () => import('@/views/college/statistics/goods-statistics'),
        meta: { title: '商品统计', icon: 'eye' }
      },
      {
        path: 'performance-overview-statistics',
        name: 'CollegeStatisticsOverview',
        component: () =>
          import('@/views/college/statistics/performance-overview-statistics'),
        meta: { title: '业绩总览', icon: 'eye' }
      },
      {
        path: 'shop-order-statistics',
        name: 'CollegeStatisticsShopOrder',
        component: () =>
          import('@/views/college/statistics/shop-order-statistics'),
        meta: { title: '店铺订单', icon: 'eye' }
      }
    ]
  },
  // 分销
  {
    path: '/college/distribution',
    component: Layout,
    redirect: '/college/distribution/index',
    name: 'CollegeDistribution',
    meta: { title: '营销', icon: 'nested' },
    children: [
      {
        path: 'index',
        component: () => import('@/views/college/distribution/index'), //  Parent router-view
        name: 'CollegeDistributionIndex',
        meta: { title: '分销活动' }
      },
      {
        path: 'records',
        component: () => import('@/views/college/distribution/records'), //  Parent router-view
        name: 'CollegeDistributionRecords',
        meta: { title: '分销记录' }
      },
      {
        path: 'rule',
        component: () => import('@/views/college/distribution/rule'), //  Parent router-view
        name: 'CollegeDistributionRule',
        meta: { title: '分销规则' }
      },
      {
        path: 'order',
        component: () => import('@/views/college/distribution/order'), //  Parent router-view
        name: 'CollegeDistributionOrder',
        meta: { title: '订单明细' }
      },
      {
        path: 'withdrawal',
        component: () => import('@/views/college/distribution/withdrawal'), //  Parent router-view
        name: 'CollegeDistributorWithdrawal',
        meta: { title: '分销提现申请记录' }
      },
      {
        path: 'distributor',
        component: () => import('@/views/college/distribution/distributor'), //  Parent router-view
        name: 'CollegeDistributor',
        meta: { title: '分销商' }
      },
      {
        path: 'advanced-distribution',
        component: () => import('@/views/college/distribution/advanced'), //  Parent router-view
        name: 'CollegeAdvancedDistribution',
        meta: { title: '高级分销' }
      },
      {
        path: 'register-record',
        component: () => import('@/views/college/distribution/register-record'), //  Parent router-view
        name: 'CollegeDestributionRegisterRecord',
        meta: { title: '注册分销记录' }
      },
      {
        path: 'distributor-examine',
        component: () =>
          import('@/views/college/distribution/distributor-examine'), //  Parent router-view
        name: 'CollegeDistributorExamine',
        meta: { title: '审核分销商' }
      }
    ]
  },
  // 零食盒子
  {
    path: '/college/snacks',
    component: Layout,
    // redirect: '/college/snacks/index',
    name: 'CollegeDistribution',
    meta: { title: '零食盒子', icon: 'nested' },
    children: [
      {
        path: 'goods-index',
        component: () => import('@/views/college/snacks/goods/index'), //  Parent router-view
        name: 'CollegeSnacksGoodsIndex',
        meta: { title: '商品管理' }
      },
      {
        path: 'goods-edit',
        component: () => import('@/views/college/snacks/goods/edit'), //  Parent router-view
        name: 'CollegeSnacksGoodsEdit',
        meta: { title: '编辑商品' }
      },
      {
        path: 'goods-type',
        component: () => import('@/views/college/snacks/goods/type'), //  Parent router-view
        name: 'CollegeSnacksGoodsType',
        meta: { title: '商品分类' }
      },
      {
        path: 'box-index',
        component: () => import('@/views/college/snacks/box/index'), //  Parent router-view
        name: 'CollegeSnacksBoxIndex',
        meta: { title: '盒子管理' }
      },
      {
        path: 'box-poster',
        component: () => import('@/views/college/snacks/box/poster-setting'), //  Parent router-view
        name: 'CollegeSnacksBoxPoster',
        meta: { title: '盒子设置' }
      },
      {
        path: 'box-type',
        component: () => import('@/views/college/snacks/box/type'), //  Parent router-view
        name: 'CollegeSnacksBoxType',
        meta: { title: '盒子分类' }
      },
      {
        path: 'box-template',
        component: () => import('@/views/college/snacks/box/template'), //  Parent router-view
        name: 'CollegeSnacksBoxTemplate',
        meta: { title: '模板列表' }
      },
      {
        path: 'car-index',
        component: () => import('@/views/college/snacks/car/index'), //  Parent router-view
        name: 'CollegeSnacksCarIndex',
        meta: { title: '配送车' }
      },
      {
        path: 'storehouse-index',
        component: () => import('@/views/college/snacks/storehouse/index'), //  Parent router-view
        name: 'CollegeSnacksStoreHouseIndex',
        meta: { title: '仓库货品' }
      },
      {
        path: 'storehouse-add',
        component: () => import('@/views/college/snacks/storehouse/add'), //  Parent router-view
        name: 'CollegeSnacksStoreHouseAdd',
        meta: { title: '入库单' }
      },
      {
        path: 'storehouse-del',
        component: () => import('@/views/college/snacks/storehouse/del'), //  Parent router-view
        name: 'CollegeSnacksStoreHouseDel',
        meta: { title: '出库单' }
      },
      {
        path: 'storehouse-detail',
        component: () => import('@/views/college/snacks/storehouse/detail'), //  Parent router-view
        name: 'CollegeSnacksStoreHouseDetail',
        meta: { title: '出入库记录' }
      },
      {
        path: 'storehouse-replenish',
        component: () => import('@/views/college/snacks/storehouse/replenish'), //  Parent router-view
        name: 'CollegeSnacksStoreHouseReplenish',
        meta: { title: '补货单' }
      },
      {
        path: 'inventory-index',
        component: () => import('@/views/college/snacks/inventory/index'), //  Parent router-view
        name: 'CollegeSnacksInventoryIndex',
        meta: { title: '盘点记录' }
      },
      {
        path: 'water-index',
        component: () => import('@/views/college/snacks/water/index'), //  Parent router-view
        name: 'CollegeSnacksWaterIndex',
        meta: { title: '资金流水' }
      },
      {
        path: 'print-setting',
        component: () =>
          import('@/views/college/snacks/car/print-configuration'), //  Parent router-view
        name: 'CollegeSnacksCarPrintConfiguration',
        meta: { title: '打印机配置' }
      },
      {
        path: 'order-index',
        component: () => import('@/views/college/snacks/order/index'), //  Parent router-view
        name: 'CollegeSnacksOrderIndex',
        meta: { title: '盒子订单' }
      },
      {
        path: 'sale-rank',
        component: () => import('@/views/college/snacks/storehouse/sale-rank'), //  Parent router-view
        name: 'CollegeSnacksStoreHouseSaleRank',
        meta: { title: '销量排行' }
      }
    ]
  },
  // 门店骑手
  {
    path: '/college/shop/waiter',
    component: Layout,
    redirect: '/college/shop/waiter/index',
    name: 'CollegeExpress',
    meta: { title: '校园专送', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'CollegeShopWaiterIndex',
        component: () => import('@/views/college/shop/waiter/index'),
        meta: { title: '骑手管理', icon: 'eye' }
      },
      {
        path: 'edit',
        name: 'CollegeShopWaiterEdit',
        component: () => import('@/views/college/shop/waiter/edit'),
        meta: { title: '添加骑手', icon: 'eye' }
      },
      {
        path: 'statistics',
        name: 'CollegeShopWaiterStatistics',
        component: () => import('@/views/college/shop/waiter/statistics'),
        meta: { title: '业绩明细', icon: 'eye' }
      }
    ]
  },
  // 同城交友
  {
    path: '/college/friend',
    component: Layout,
    // redirect: '/college/supplier/index',
    // name: 'Supplier',
    meta: { title: '同城交友', icon: 'nested' },
    children: [
      {
        path: 'user-index',
        name: 'CollegeFriendUserIndex',
        component: () => import('@/views/college/friend/user/index'),
        meta: { title: '用户列表', icon: 'form' }
      },
      {
        path: 'user-edit',
        name: 'CollegeFriendUserEdit',
        component: () => import('@/views/college/friend/user/edit'),
        meta: { title: '用户详情', icon: 'form' }
      },
      {
        path: 'interest',
        name: 'CollegeFriendInterest',
        component: () => import('@/views/college/friend/interest/index'),
        meta: { title: '兴趣话题', icon: 'form' }
      },
      {
        path: 'dynamic',
        name: 'CollegeFriendDynamic',
        component: () => import('@/views/college/friend/dynamic/index'),
        meta: { title: '动态管理', icon: 'form' }
      },
      {
        path: 'complaint',
        name: 'CollegeFriendComplaint',
        component: () => import('@/views/college/friend/complaint/index'),
        meta: { title: '投诉管理', icon: 'form' }
      },
      {
        path: 'notice',
        name: 'CollegeFriendNotice',
        component: () => import('@/views/college/friend/notice/index'),
        meta: { title: '通知设置', icon: 'form' }
      },
      {
        path: 'advertisement',
        name: 'CollegeFriendAdvertisement',
        component: () => import('@/views/college/friend/advertisement/index'),
        meta: { title: '流量主广告', icon: 'form' }
      }
    ]
  },
  // 站点运营考核
  {
    path: '/college/operate',
    component: Layout,
    redirect: '/college/operate/exam',
    // name: 'CollegeApplication',
    // meta: { title: '站点运营考核', icon: 'example' },
    children: [
      {
        path: 'exam',
        name: 'CollegeOperateExam',
        component: () => import('@/views/college/operate/exam'),
        meta: { title: '站点运营考核', icon: 'eye' }
      }
    ]
  },

  // **************************高校新增菜单END*********************************
  // 应聘管理
  {
    path: '/auspicious/recruit',
    component: Layout,
    redirect: '/auspicious/recruit',
    name: 'TestIndex',
    // meta: { title: '应聘管理', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'AuspiciousRecruitIndex',
        component: () => import('@/views/auspicious/recruit/index'),
        meta: { title: '应聘管理', icon: 'eye' }
      }
    ]
  },
  // 推荐规则
  {
    path: '/auspicious/rule',
    component: Layout,
    redirect: '/auspicious/rule',
    name: 'AuspiciousRule',
    // meta: { title: '应聘管理', icon: 'example' },
    children: [
      {
        path: 'recommend',
        name: 'AuspiciousRuleRecommend',
        component: () => import('@/views/auspicious/rule/recommend'),
        meta: { title: '推荐规则', icon: 'eye' }
      }
    ]
  },
  // 员工中心
  {
    path: '/auspicious/employee',
    component: Layout,
    redirect: '/auspicious/employee/staff',
    name: 'AuspiciousEmployee',
    meta: { title: '员工中心', icon: 'example' },
    children: [
      {
        path: 'staff',
        name: 'AuspiciousEmployeeStaff',
        component: () => import('@/views/auspicious/employee/staff'),
        meta: { title: '员工列表', icon: 'eye' }
      },
      {
        path: 'wage-records',
        name: 'AuspiciousEmployeeWageRecords',
        component: () => import('@/views/auspicious/employee/wage-records'),
        meta: { title: '工资记录', icon: 'eye' }
      },
      {
        path: 'quit-records',
        name: 'AuspiciousEmployeeQuitRecords',
        component: () => import('@/views/auspicious/employee/quit-records'),
        meta: { title: '员工离职记录', icon: 'eye' }
      },
      {
        path: 'wage-cash-out-records',
        name: 'AuspiciousEmployeeWageCashOutRecords',
        component: () =>
          import('@/views/auspicious/employee/wage-cash-out-records'),
        meta: { title: '工资提现记录', icon: 'eye' }
      },
      {
        path: 'bonus-cash-out-records',
        name: 'AuspiciousEmployeeBonusCashOutRecords',
        component: () =>
          import('@/views/auspicious/employee/bonus-cash-out-records'),
        meta: { title: '奖金提现记录', icon: 'eye' }
      }
    ]
  },
  // 招聘管理-企业管理
  {
    path: '/auspicious',
    component: Layout,
    redirect: '/auspicious/enterprise-manage',
    name: 'AuspiciousEnterPriceManage',
    meta: { title: '招聘管理', icon: 'example' },
    children: [
      {
        path: 'enterprise-manage/index',
        name: 'AuspiciousEnterPriceIndex',
        component: () => import('@/views/auspicious/enterprise-manage/index'),
        meta: { title: '企业管理', icon: 'eye' }
      },
      {
        path: 'enterprise-manage/edit-enterprise',
        name: 'AuspiciousEditEnterPrice',
        component: () =>
          import('@/views/auspicious/enterprise-manage/edit-enterprise'),
        meta: { title: '新增企业', icon: 'eye' }
      }
    ]
  },
  // 招聘管理-岗位管理
  {
    path: '/auspicious',
    component: Layout,
    redirect: '/auspicious/work-post-manage',
    name: 'AuspiciousWorkPostManage',
    meta: { title: '招聘管理', icon: 'example' },
    children: [
      {
        path: 'work-post-manage/index',
        name: 'AuspiciousWorkPostIndex',
        component: () => import('@/views/auspicious/work-post-manage/index'),
        meta: { title: '岗位管理', icon: 'eye' }
      },
      {
        path: 'work-post-manage/edit-work-post',
        name: 'AuspiciousEditWorkPost',
        component: () =>
          import('@/views/auspicious/work-post-manage/edit-work-post'),
        meta: { title: '新增岗位', icon: 'eye' }
      }
    ]
  },
  // 霸王餐活动
  {
    path: '/overlord',
    component: Layout,
    // redirect: '/overlord/index',
    name: 'Overlord',
    meta: { title: '霸王餐活动', icon: 'example' },
    children: [
      {
        path: 'examine-record',
        name: 'OverlordExamineRecord',
        component: () => import('@/views/overlord/examine-record'),
        meta: { title: '审核记录', icon: 'eye' }
      },
      {
        path: 'task-examine',
        name: 'OverlordTaskExamine',
        component: () => import('@/views/overlord/task-examine'),
        meta: { title: '任务审批', icon: 'eye' }
      },
      {
        path: 'balance-record',
        name: 'OverlordBalanceRecord',
        component: () => import('@/views/overlord/balance-record'),
        meta: { title: '余额记录', icon: 'eye' }
      },
      {
        path: 'shop',
        name: 'OverlordShop',
        component: () => import('@/views/overlord/shop'),
        meta: { title: '商户列表', icon: 'eye' }
      },
      {
        path: 'shop-edti',
        name: 'OverlordShopEdit',
        component: () => import('@/views/supplier/edit-shop'),
        meta: { title: '供应商门店', icon: 'eye' }
      },
      {
        path: 'data-board',
        name: 'OverlordDataBoard',
        component: () => import('@/views/overlord/data-board'),
        meta: { title: '数据看板', icon: 'eye' }
      },
      {
        path: 'withdrawal',
        name: 'OverlordWithdrawal',
        component: () => import('@/views/overlord/withdrawal'),
        meta: { title: '提现记录', icon: 'eye' }
      },
      {
        path: 'chain-balance-water',
        component: () => import('@/views/overlord/chain-balance-water'), //  Parent router-view
        name: 'ChainBalanceWater',
        meta: { title: '连锁品牌余额流水' }
      },
      {
        path: 'shop-withdrawal',
        component: () => import('@/views/overlord/shop/withdrawal'), //  Parent router-view
        name: 'OverlordShopWithdrawal',
        meta: { title: '商家提现' }
      }
    ]
  },
  // **************************商场模式新增菜单*********************************
  // 商品
  {
    path: '/market/goods',
    component: Layout,
    redirect: 'market/goods/goods-list',
    name: 'goods',
    meta: { title: '商品', icon: 'icon iconfont iconshangpin' },
    children: [
      {
        path: 'goods-list',
        name: 'MarketGoodsList',
        component: () => import('@/views/market/goods/goods-list'),
        meta: { title: '商品列表', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'type-mgmt',
        name: 'MarketGoodsTypeManagement',
        component: () => import('@/views/market/goods/type-mgmt'),
        meta: { title: '商品分类', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'edit',
        name: 'marketGoodsEdit',
        component: () => import('@/views/market/goods/edit'),
        meta: { title: '新增商品', icon: 'icon iconfont iconshangpin' }
      }
      // {
      //   path: 'label-management',
      //   name: 'LabelManagement',
      //   component: () => import('@/views/goods/label-management'),
      //   meta: { title: '标签管理', icon: 'icon iconfont iconshangpin' }
      // }
    ]
  },
  // 分销储备金
  {
    path: '/market/distri-reserve',
    component: Layout,
    redirect: 'market/distri-reserve/balance',
    meta: { title: '分销储备金', icon: 'icon iconfont iconshangpin' },
    children: [
      {
        path: 'balance',
        name: 'MarketDistriReserveBalance',
        component: () => import('@/views/market/distri-reserve/balance'),
        meta: { title: '多门店分销对账', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'detail',
        name: 'MarketDistriReserveDetail',
        component: () => import('@/views/market/distri-reserve/detail'),
        meta: { title: '分销明细', icon: 'icon iconfont iconshangpin' }
      },
      {
        path: 'withdrawal',
        name: 'MarketDistriReserveWithdrawal',
        component: () => import('@/views/market/distri-reserve/withdrawal'),
        meta: { title: '提现管理', icon: 'icon iconfont iconshangpin' }
      }
    ]
  },
  // 朱雀电竞
  {
    path: '/activity',
    component: Layout,
    // redirect: '/activity/project/index',
    // name: 'CollegeApplication',
    meta: { title: '活动', icon: 'example' },
    children: [
      {
        path: 'project/index',
        name: 'ActivityProjectIndex',
        component: () => import('@/views/activity/project/index'),
        meta: { title: '活动项目', icon: 'eye' }
      },
      {
        path: 'match/index',
        name: 'ActivityMatchIndex',
        component: () => import('@/views/activity/match/index'),
        meta: { title: '活动管理', icon: 'eye' }
      },
      {
        path: 'match/edit',
        name: 'ActivityMatchEdit',
        component: () => import('@/views/activity/match/edit'),
        meta: { title: '活动详情', icon: 'eye' }
      },
      {
        path: 'match/process',
        name: 'ActivityMatchProcess',
        component: () => import('@/views/activity/match/process'),
        meta: { title: '活动进程', icon: 'eye' }
      },
      {
        path: 'match/sign-up',
        name: 'ActivityMatchSignUp',
        component: () => import('@/views/activity/match/sign-up'),
        meta: { title: '活动报名', icon: 'eye' }
      },
      {
        path: 'team/index',
        name: 'ActivityTeamIndex',
        component: () => import('@/views/activity/team/index'),
        meta: { title: '战队管理', icon: 'eye' }
      }
    ]
  },
  // 停车管理
  {
    path: '/parking',
    component: Layout,
    // redirect: '/test/index',
    // name: 'TestIndex',
    meta: { title: '停车管理', icon: 'example' },
    children: [
      {
        path: 'payment-record',
        name: 'ParkingPaymentRecord',
        component: () => import('@/views/parking-mgmt/payment-record/index'),
        meta: { title: '缴费记录', icon: 'eye' }
      },
      {
        path: 'integral-rule',
        name: 'ParkingIntegralRule',
        component: () => import('@/views/parking-mgmt/integral-rule/index'),
        meta: { title: '积分规则', icon: 'eye' }
      }
    ]
  },
  // 微信广告
  // {
  //   path: '/advertisement',
  //   component: Layout,
  //   redirect: '/advertisement/index',
  //   name: 'Advertisement',
  //   meta: { title: '微信广告', icon: 'example' },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'AdvertisementIndex',
  //       component: () => import('@/views/advertisement/index'),
  //       meta: { title: '微信广告', icon: 'eye' }
  //     }
  //   ]
  // },
  // 测试
  {
    path: '/test',
    component: Layout,
    redirect: '/test/index',
    name: 'TestIndex',
    meta: { title: '测试', icon: 'example' },
    children: [
      {
        path: 'index',
        name: 'TestIndex',
        component: () => import('@/views/test/index'),
        meta: { title: '测试', icon: 'eye' }
      }
    ]
  },
  //  404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    //  mode: 'history', //  require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

//   Detail see: https: //  github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher //  reset router
}

export default router
